/* Keep supported mobile browser chrome black instead of inheriting a campaign colour. */
(function () {
  var themeColor = document.querySelector('meta[name="theme-color"]');

  if (!themeColor) {
    themeColor = document.createElement('meta');
    themeColor.name = 'theme-color';
    document.head.appendChild(themeColor);
  }

  themeColor.content = '#000000';
})();

/* Herbz language/market routing.
 * All language pickers share the mapping rendered by
 * snippets/herbz-market-language-options.liquid. Shopify's localization form
 * remains responsible for switching market, language, currency and domain.
 */
(function () {
  if (window.__herbzMarketLanguagePickerInitialized) return;
  window.__herbzMarketLanguagePickerInitialized = true;

  var optionSelector = '[data-herbz-market-option]';

  function normalizedHost(value) {
    return String(value || '').toLowerCase().replace(/^www\./, '');
  }

  function languageCode(value) {
    return String(value || '').toLowerCase().split('-')[0];
  }

  function findAlternate(option) {
    var locale = languageCode(option && option.value);
    var expectedHost = normalizedHost(option && option.dataset.domain);
    if (!locale || !expectedHost) return null;

    return Array.prototype.find.call(
      document.querySelectorAll('link[rel="alternate"][hreflang][href]'),
      function (link) {
        if (languageCode(link.getAttribute('hreflang')) !== locale) return false;
        try {
          return normalizedHost(new URL(link.href, window.location.href).hostname) === expectedHost;
        } catch (error) {
          return false;
        }
      }
    ) || null;
  }

  function enablePublishedLocales(root) {
    (root || document).querySelectorAll('[data-requires-published-locale="true"]').forEach(function (option) {
      if (!findAlternate(option)) return;

      option.disabled = false;
      option.removeAttribute('aria-disabled');
      option.classList.remove('is-unavailable');

      var unavailableLabel = option.querySelector && option.querySelector('[data-herbz-unavailable-label]');
      if (unavailableLabel) unavailableLabel.remove();
      if (option.tagName === 'OPTION' && option.dataset.languageName) {
        option.textContent = option.dataset.languageName;
      }
    });
  }

  function prepareLocalizationForm(option) {
    var form = option && option.closest('form');
    if (!form) return null;

    var countryInput = form.querySelector('[data-herbz-market-country]');
    if (countryInput && option.dataset.countryCode) {
      countryInput.value = option.dataset.countryCode;
    }

    var alternate = findAlternate(option);
    var targetDomain = normalizedHost(option.dataset.domain);
    var targetOrigin = '';

    if (alternate) {
      try {
        targetOrigin = new URL(alternate.href, window.location.href).origin;
      } catch (error) {}
    }

    if (!targetOrigin && /^[a-z0-9.-]+$/.test(targetDomain)) {
      targetOrigin = 'https://' + targetDomain;
    }

    if (targetOrigin) {
      form.action = targetOrigin + '/localization';
    }

    if (alternate) {
      var returnInput = form.querySelector('input[name="return_to"]');
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        form.appendChild(returnInput);
      }

      try {
        var target = new URL(alternate.href, window.location.href);
        returnInput.value = target.pathname + target.search + target.hash;
      } catch (error) {
        returnInput.value = '/';
      }
    }

    return form;
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    var option = event.target.closest(optionSelector + ':not(option)');
    if (!option) return;
    if (option.disabled || option.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      return;
    }
    prepareLocalizationForm(option);
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    var select = event.target.closest('[data-herbz-market-select]');
    if (!select) return;

    var option = select.options[select.selectedIndex];
    if (!option || option.disabled) return;
    var form = prepareLocalizationForm(option);
    if (!form || form.dataset.herbzSubmitting === 'true') return;

    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.querySelector(optionSelector)) return;
    if (form.dataset.herbzSubmitting === 'true') {
      event.preventDefault();
      return;
    }
    form.dataset.herbzSubmitting = 'true';
    form.setAttribute('aria-busy', 'true');
  }, true);

  function hydrate() {
    enablePublishedLocales(document);
  }

  function cleanShopifyMarketTransitionParameter() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('shpxid')) return;

      url.searchParams.delete('shpxid');
      var cleanUrl = url.pathname + url.search + url.hash;
      window.history.replaceState(window.history.state, '', cleanUrl);
    } catch (error) {
      // The market switch has already completed; URL cleanup is cosmetic only.
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate);
  else hydrate();

  if (document.readyState === 'complete') {
    window.setTimeout(cleanShopifyMarketTransitionParameter, 0);
  } else {
    window.addEventListener('load', cleanShopifyMarketTransitionParameter, { once: true });
  }

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-requires-published-locale="true"]')) {
          enablePublishedLocales(node.parentElement || document);
        } else if (node.querySelector) {
          enablePublishedLocales(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('form[data-herbz-submitting="true"]').forEach(function (form) {
      delete form.dataset.herbzSubmitting;
      form.removeAttribute('aria-busy');
    });
    hydrate();
    cleanShopifyMarketTransitionParameter();
  });
})();

/* Herbz custom Gorgias launcher. The native launcher remains as a fallback
 * until Gorgias' supported JavaScript API has initialized successfully. */
(function () {
  if (window.__herbzGorgiasLauncherInitialized) return;
  window.__herbzGorgiasLauncherInitialized = true;

  var copyByLanguage = {
    da: { eyebrow: 'HERBZ SUPPORT', label: 'Spørg Herbz', close: 'Luk chatten' },
    en: { eyebrow: 'HERBZ SUPPORT', label: 'Ask Herbz', close: 'Close chat' },
    sv: { eyebrow: 'HERBZ SUPPORT', label: 'Fråga Herbz', close: 'Stäng chatten' },
    de: { eyebrow: 'HERBZ SUPPORT', label: 'Herbz fragen', close: 'Chat schließen' },
    fr: { eyebrow: 'SUPPORT HERBZ', label: 'Demander à Herbz', close: 'Fermer le chat' },
    es: { eyebrow: 'SOPORTE HERBZ', label: 'Pregunta a Herbz', close: 'Cerrar el chat' },
    it: { eyebrow: 'SUPPORTO HERBZ', label: 'Chiedi a Herbz', close: 'Chiudi la chat' },
    cs: { eyebrow: 'PODPORA HERBZ', label: 'Zeptejte se Herbz', close: 'Zavřít chat' }
  };

  function getCopy() {
    var language = String(document.documentElement.lang || 'da').toLowerCase().split('-')[0];
    return copyByLanguage[language] || copyByLanguage.da;
  }

  function mountLauncher() {
    var api = window.GorgiasChat;
    if (!api || typeof api.open !== 'function' || typeof api.close !== 'function') return;
    if (document.getElementById('HerbzGorgiasLauncher')) return;

    var copy = getCopy();
    var launcher = document.createElement('button');
    launcher.id = 'HerbzGorgiasLauncher';
    launcher.className = 'herbz-gorgias-launcher';
    launcher.type = 'button';
    launcher.setAttribute('aria-label', copy.label);
    launcher.setAttribute('aria-expanded', 'false');
    launcher.innerHTML =
      '<span class="herbz-gorgias-launcher__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24"><path d="M5.2 5.5h13.6v9.8H11l-4.6 3v-3H5.2z"/><path d="M8.5 9.2h7M8.5 12h4.8"/></svg>' +
        '<span class="herbz-gorgias-launcher__status"></span>' +
      '</span>' +
      '<span class="herbz-gorgias-launcher__copy">' +
        '<small>' + copy.eyebrow + '</small>' +
        '<strong>' + copy.label + '</strong>' +
      '</span>' +
      '<span class="herbz-gorgias-launcher__arrow" aria-hidden="true">↗</span>';

    function syncOpenState(open) {
      launcher.classList.toggle('is-open', Boolean(open));
      launcher.setAttribute('aria-expanded', open ? 'true' : 'false');
      launcher.setAttribute('aria-label', open ? copy.close : copy.label);
    }

    launcher.addEventListener('click', function () {
      var isOpen = typeof api.isOpen === 'function' && api.isOpen();
      if (isOpen) api.close();
      else api.open();
      syncOpenState(!isOpen);
    });

    if (typeof api.on === 'function') {
      api.on('widget:opened', function () { syncOpenState(true); });
      api.on('widget:closed', function () { syncOpenState(false); });
    }

    document.body.appendChild(launcher);
    document.documentElement.classList.add('herbz-gorgias-custom-ready');
  }

  var gorgiasReady = window.GorgiasChat && typeof window.GorgiasChat.init === 'function'
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener('gorgias-widget-loaded', resolve, { once: true });
      });

  Promise.resolve(gorgiasReady).then(mountLauncher).catch(function () {
    /* Keep Gorgias' native launcher visible if its API is unavailable. */
  });
})();

/* Herbz storefront translations.
 * Keep this near the beginning: product-card labels must still translate if later custom
 * JavaScript encounters an unrelated error.
 */
(function () {
  var dictionaries = {
    da: {
      chooseVariant: 'Vælg variant',
      variantsFor: 'Varianter for',
      addToCart: 'Læg i kurv',
      addPackage: 'Læg pakken i kurven',
      soldOut: 'Udsolgt',
      newProduct: 'Nyt produkt',
      comingSoon: 'Kommer snart',
      popular: 'Populær',
      save: 'Spar',
      bestValue: 'Bedste værdi',
      from: 'Fra',
      perGram: 'pr. g',
      readMore: 'Læs mere',
      lowThca: 'lav THCA',
      highThca: 'høj THCA'
    },
    en: {
      chooseVariant: 'Choose variant',
      variantsFor: 'Variants for',
      addToCart: 'Add to cart',
      addPackage: 'Add package to cart',
      soldOut: 'Sold out',
      newProduct: 'New product',
      comingSoon: 'Coming soon',
      popular: 'Popular',
      save: 'Save',
      bestValue: 'Best value',
      from: 'From',
      perGram: 'per g',
      readMore: 'Read more',
      lowThca: 'low THCA',
      highThca: 'high THCA'
    },
    fr: {
      chooseVariant: 'Choisir une variante',
      variantsFor: 'Variantes pour',
      addToCart: 'Ajouter au panier',
      addPackage: 'Ajouter le lot au panier',
      soldOut: 'Épuisé',
      newProduct: 'Nouveau produit',
      comingSoon: 'Bientôt disponible',
      popular: 'Populaire',
      save: 'Économisez',
      bestValue: 'Meilleur choix',
      from: 'À partir de',
      perGram: 'par g',
      readMore: 'En savoir plus',
      lowThca: 'THCA faible',
      highThca: 'THCA élevé'
    },
    de: {
      chooseVariant: 'Variante wählen',
      variantsFor: 'Varianten für',
      addToCart: 'In den Warenkorb',
      addPackage: 'Paket in den Warenkorb',
      soldOut: 'Ausverkauft',
      newProduct: 'Neues Produkt',
      comingSoon: 'Demnächst verfügbar',
      popular: 'Beliebt',
      save: 'Spare',
      bestValue: 'Bestes Angebot',
      from: 'Ab',
      perGram: 'pro g',
      readMore: 'Mehr erfahren',
      lowThca: 'niedriges THCA',
      highThca: 'hohes THCA'
    },
    es: {
      chooseVariant: 'Elegir variante',
      variantsFor: 'Variantes para',
      addToCart: 'Añadir al carrito',
      addPackage: 'Añadir paquete al carrito',
      soldOut: 'Agotado',
      newProduct: 'Producto nuevo',
      comingSoon: 'Próximamente',
      popular: 'Popular',
      save: 'Ahorra',
      bestValue: 'Mejor opción',
      from: 'Desde',
      perGram: 'por g',
      readMore: 'Leer más',
      lowThca: 'THCA bajo',
      highThca: 'THCA alto'
    },
    sv: {
      chooseVariant: 'Välj variant',
      variantsFor: 'Varianter för',
      addToCart: 'Lägg i varukorgen',
      addPackage: 'Lägg paketet i varukorgen',
      soldOut: 'Slutsåld',
      newProduct: 'Ny produkt',
      comingSoon: 'Kommer snart',
      popular: 'Populär',
      save: 'Spara',
      bestValue: 'Bäst värde',
      from: 'Från',
      perGram: 'per g',
      readMore: 'Läs mer',
      lowThca: 'låg THCA',
      highThca: 'hög THCA'
    },
    it: {
      chooseVariant: 'Scegli variante',
      variantsFor: 'Varianti per',
      addToCart: 'Aggiungi al carrello',
      addPackage: 'Aggiungi il pacchetto al carrello',
      soldOut: 'Esaurito',
      newProduct: 'Nuovo prodotto',
      comingSoon: 'Prossimamente',
      popular: 'Popolare',
      save: 'Risparmia',
      bestValue: 'Miglior valore',
      from: 'Da',
      perGram: 'per g',
      readMore: 'Scopri di più',
      lowThca: 'THCA basso',
      highThca: 'THCA alto'
    },
    cs: {
      chooseVariant: 'Vybrat variantu',
      variantsFor: 'Varianty pro',
      addToCart: 'Přidat do košíku',
      addPackage: 'Přidat balíček do košíku',
      soldOut: 'Vyprodáno',
      newProduct: 'Nový produkt',
      comingSoon: 'Již brzy',
      popular: 'Oblíbené',
      save: 'Ušetříte',
      bestValue: 'Nejlepší hodnota',
      from: 'Od',
      perGram: 'za g',
      readMore: 'Více informací',
      lowThca: 'nízké THCA',
      highThca: 'vysoké THCA'
    }
  };
  var fromPrefixes = Object.keys(dictionaries).reduce(function (all, key) {
    var value = dictionaries[key].from;
    all.push(value + ' ', value.toUpperCase() + ' ', value.toLowerCase() + ' ');
    return all;
  }, []);

  function currentLabels() {
    var language = String(document.documentElement.lang || 'da').toLowerCase().split('-')[0];
    return dictionaries[language] || dictionaries.da;
  }

  window.getHerbzVariantTranslations = currentLabels;

  function replacePrefix(value, prefixes, replacement) {
    var text = String(value || '');
    for (var i = 0; i < prefixes.length; i += 1) {
      if (text.indexOf(prefixes[i]) === 0) return replacement + text.slice(prefixes[i].length);
    }
    return text;
  }

  function replaceElementPrefix(element, prefixes, replacement) {
    if (!element) return;

    for (var i = 0; i < element.childNodes.length; i += 1) {
      var node = element.childNodes[i];
      if (node.nodeType !== 3 || !node.nodeValue.trim()) continue;

      var leadingWhitespace = (node.nodeValue.match(/^\s*/) || [''])[0];
      var text = node.nodeValue.slice(leadingWhitespace.length);
      var translated = replacePrefix(text, prefixes, replacement);
      if (translated !== text) node.nodeValue = leadingWhitespace + translated;
      return;
    }

    var current = element.textContent.trim();
    var translatedText = replacePrefix(current, prefixes, replacement);
    if (translatedText !== current) element.textContent = translatedText;
  }

  function translateFromTextNode(node) {
    if (!node || node.nodeType !== 3 || !node.nodeValue || !node.nodeValue.trim()) return;
    if (!node.parentElement || !node.parentElement.closest('product-card, .card-wrapper')) return;

    var labels = currentLabels();
    var leadingWhitespace = (node.nodeValue.match(/^\s*/) || [''])[0];
    var text = node.nodeValue.slice(leadingWhitespace.length);
    var translated = replacePrefix(text, fromPrefixes, labels.from + ' ');
    if (translated !== text) node.nodeValue = leadingWhitespace + translated;
  }

  function translateFromTree(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      translateFromTextNode(root);
      return;
    }
    if (!root.querySelectorAll) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) translateFromTextNode(node);
  }

  function translateProductCardLabels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var labels = currentLabels();
    var knownChoose = Object.keys(dictionaries).map(function (key) { return dictionaries[key].chooseVariant; });
    var knownVariants = Object.keys(dictionaries).map(function (key) { return dictionaries[key].variantsFor; });
    var knownAdd = Object.keys(dictionaries).reduce(function (all, key) {
      all.push(dictionaries[key].addToCart, dictionaries[key].addPackage);
      return all;
    }, []);
    var knownSoldOut = Object.keys(dictionaries).map(function (key) { return dictionaries[key].soldOut; });
    var knownPopular = Object.keys(dictionaries).map(function (key) { return dictionaries[key].popular; });
    var knownSave = Object.keys(dictionaries).map(function (key) { return dictionaries[key].save; });
    var knownBestValue = Object.keys(dictionaries).map(function (key) { return dictionaries[key].bestValue; });
    var knownNewProduct = Object.keys(dictionaries).map(function (key) { return dictionaries[key].newProduct; });
    var knownComingSoon = Object.keys(dictionaries).map(function (key) { return dictionaries[key].comingSoon; });
    var knownReadMore = Object.keys(dictionaries).map(function (key) { return dictionaries[key].readMore; });
    var cards = [];
    if (scope.matches && scope.matches('product-card, .card-wrapper')) cards.push(scope);
    scope.querySelectorAll('product-card, .card-wrapper').forEach(function (card) {
      if (cards.indexOf(card) === -1) cards.push(card);
    });

    cards.forEach(function (card) {
      translateFromTree(card);
    });

    scope.querySelectorAll('[data-card-custom-variant-toggle]').forEach(function (toggle) {
      var text = toggle.querySelector('[data-card-custom-variant-label]');
      if (text && knownChoose.indexOf(text.textContent.trim()) !== -1) text.textContent = labels.chooseVariant;
      toggle.dataset.defaultLabel = labels.chooseVariant;
      toggle.setAttribute('aria-label', replacePrefix(toggle.getAttribute('aria-label'), knownChoose, labels.chooseVariant));
    });

    scope.querySelectorAll('[data-card-custom-variant-menu]').forEach(function (menu) {
      menu.setAttribute('aria-label', replacePrefix(menu.getAttribute('aria-label'), knownVariants, labels.variantsFor));
    });

    scope.querySelectorAll('[data-add-to-cart-label]').forEach(function (element) {
      var current = element.textContent.trim();
      var translated = current;
      if (knownChoose.indexOf(current) !== -1) translated = labels.chooseVariant;
      else if (knownAdd.indexOf(current) !== -1) translated = labels.addToCart;
      element.textContent = translated;
      element.dataset.label = translated;

      var button = element.closest('button');
      if (button) {
        var ariaLabel = button.getAttribute('aria-label');
        var translatedAria = replacePrefix(ariaLabel, knownChoose, labels.chooseVariant);
        translatedAria = replacePrefix(translatedAria, knownAdd, labels.addPackage);
        button.setAttribute('aria-label', translatedAria);
      }
    });

    scope.querySelectorAll('[data-sold-out-label]').forEach(function (element) {
      if (knownSoldOut.indexOf(element.textContent.trim()) !== -1) element.textContent = labels.soldOut;
      element.dataset.label = labels.soldOut;
    });

    scope.querySelectorAll('.card-variant-custom__badge--popular').forEach(function (element) {
      if (knownPopular.indexOf(element.textContent.trim()) !== -1) element.textContent = labels.popular;
    });

    scope.querySelectorAll('.card-variant-custom__badge--best').forEach(function (element) {
      if (knownBestValue.indexOf(element.textContent.trim()) !== -1) element.textContent = labels.bestValue;
    });

    scope.querySelectorAll('.card-variant-custom__badge--compare').forEach(function (element) {
      replaceElementPrefix(element, knownSave, labels.save);
    });

    scope.querySelectorAll('.card-variant-custom__badge--soldout').forEach(function (element) {
      if (knownSoldOut.indexOf(element.textContent.trim()) !== -1) element.textContent = labels.soldOut;
    });

    scope.querySelectorAll('.herbz-coming-soon-overlay__eyebrow').forEach(function (element) {
      if (knownNewProduct.indexOf(element.textContent.trim()) !== -1) element.textContent = labels.newProduct;
    });

    scope.querySelectorAll('.herbz-coming-soon-overlay__title').forEach(function (element) {
      if (knownComingSoon.indexOf(element.textContent.trim()) !== -1) element.textContent = labels.comingSoon;
    });

    scope.querySelectorAll('.herbz-card-read-more').forEach(function (link) {
      var label = link.querySelector('.herbz-card-read-more__label');
      if (label && knownReadMore.indexOf(label.textContent.trim()) !== -1) label.textContent = labels.readMore;
      var ariaLabel = link.getAttribute('aria-label');
      if (ariaLabel) link.setAttribute('aria-label', replacePrefix(ariaLabel, knownReadMore, labels.readMore));
    });

    scope.querySelectorAll('.herbz-card-purchase-intro__gram-price').forEach(function (price) {
      var parts = Array.prototype.filter.call(price.children, function (child) {
        return child.tagName === 'SPAN';
      });
      if (parts[0]) parts[0].textContent = labels.from;
      if (parts[1]) parts[1].textContent = labels.perGram;
    });

    scope.querySelectorAll('.herbz-card-purchase-potency__labels, .card-package-meter__labels').forEach(function (row) {
      var parts = row.querySelectorAll('span');
      if (parts[0]) parts[0].textContent = labels.lowThca;
      if (parts[1]) parts[1].textContent = labels.highThca;
    });

    scope.querySelectorAll('product-card[data-coming-soon="true"]').forEach(function (card) {
      var productTitle = card.getAttribute('data-product-title') || '';
      card.setAttribute('aria-label', productTitle ? productTitle + ' – ' + labels.comingSoon : labels.comingSoon);
    });
  }

  function translateCzechTrustpilotWidgets(root) {
    var language = String(document.documentElement.lang || '').toLowerCase().split('-')[0];
    if (language !== 'cs') return;

    var scope = root && root.querySelectorAll ? root : document;
    var widgets = [];
    if (scope.matches && scope.matches('.trustpilot-widget')) widgets.push(scope);
    scope.querySelectorAll('.trustpilot-widget').forEach(function (widget) {
      if (widgets.indexOf(widget) === -1) widgets.push(widget);
    });
    if (!widgets.length) return;

    if (!document.getElementById('HerbzCzechTrustpilotStyles')) {
      var style = document.createElement('style');
      style.id = 'HerbzCzechTrustpilotStyles';
      style.textContent = '.herbz-trustpilot-cs{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:.8rem 1.2rem;color:#fff;font:700 14px/1.2 Arial,sans-serif;text-decoration:none}.herbz-trustpilot-cs strong{font-size:18px}.herbz-trustpilot-cs__stars{display:inline-flex;gap:2px}.herbz-trustpilot-cs__stars i{display:grid;place-items:center;width:24px;height:24px;background:#00b67a;color:#fff;font-style:normal;line-height:1}.herbz-trustpilot-cs__stars i.is-half{background:linear-gradient(90deg,#00b67a 55%,#dcdce6 55%)}.herbz-trustpilot-cs b{white-space:nowrap;font-size:15px}.herbz-trustpilot-cs b i{color:#00b67a;font-style:normal;font-size:20px}.herbz-trustpilot-cs u{text-underline-offset:2px}@media(max-width:749px){.herbz-trustpilot-cs{gap:6px 8px;font-size:12px}.herbz-trustpilot-cs>span:first-child{width:100%;text-align:center}.herbz-trustpilot-cs strong{font-size:15px}.herbz-trustpilot-cs__stars i{width:20px;height:20px}}';
      document.head.appendChild(style);
    }

    widgets.forEach(function (widget) {
      var fallback = document.createElement('a');
      fallback.className = 'herbz-trustpilot-cs';
      fallback.href = 'https://www.trustpilot.com/review/herbz.dk';
      fallback.target = '_blank';
      fallback.rel = 'noopener';
      fallback.setAttribute('aria-label', 'Herbz na Trustpilotu: 4,6 z 5 na základě 507 recenzí');
      fallback.innerHTML = '<span>Naši zákazníci říkají</span><strong>Vynikající</strong><span class="herbz-trustpilot-cs__stars" aria-hidden="true"><i>★</i><i>★</i><i>★</i><i>★</i><i class="is-half">★</i></span><span>4,6 z 5 na základě <u>507 recenzí</u></span><b><i aria-hidden="true">★</i> Trustpilot</b>';
      widget.replaceWith(fallback);
    });
  }

  function bootTranslations() {
    translateProductCardLabels(document);
    translateCzechTrustpilotWidgets(document);
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            translateProductCardLabels(node);
            translateFromTree(node);
            translateCzechTrustpilotWidgets(node);
          } else if (node.nodeType === 3) {
            translateFromTextNode(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootTranslations, { once: true });
  } else {
    bootTranslations();
  }
})();

/* Remove Vitals' original-DKK hover label without removing the currency data
   attributes used by the converter itself. */
(function () {
  var priceSelector = '.money[data-vitals-cc-dkk]';
  var tooltipSelector = [
    '.vttooltiptext',
    '[class*="vitals" i][class*="tooltip" i]',
    '[class*="currency" i][class*="tooltip" i]'
  ].join(',');

  function cleanPrice(price) {
    if (!price || !price.matches || !price.matches(priceSelector)) return;
    price.removeAttribute('title');
    price.removeAttribute('data-original-title');
    price.removeAttribute('data-tooltip');
    price.classList.remove('vttooltip');
    price.querySelectorAll('.vttooltiptext').forEach(function (tooltip) {
      tooltip.remove();
    });
  }

  function cleanCurrencyTooltips(root) {
    if (!root || !root.querySelectorAll) return;

    if (root.matches && root.matches(priceSelector)) cleanPrice(root);
    root.querySelectorAll(priceSelector).forEach(cleanPrice);

    if (root.matches && root.matches(tooltipSelector)) root.remove();
    root.querySelectorAll(tooltipSelector).forEach(function (tooltip) {
      tooltip.remove();
    });
  }

  function initializeCurrencyTooltipCleanup() {
    cleanCurrencyTooltips(document);

    if (!document.body || document.body.dataset.herbzCurrencyTooltipCleanup === 'true') return;
    document.body.dataset.herbzCurrencyTooltipCleanup = 'true';

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          cleanPrice(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) cleanCurrencyTooltips(node);
        });
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['title', 'data-original-title', 'data-tooltip']
    });
  }

  document.addEventListener('pointerover', function (event) {
    var price = event.target.closest && event.target.closest(priceSelector);
    if (price) cleanPrice(price);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCurrencyTooltipCleanup);
  } else {
    initializeCurrencyTooltipCleanup();
  }
})();

const sliderInit = (section) => {
  if (!section) return;
  const mediaLists = section.querySelectorAll(".js-media-list");
  if (mediaLists.length === 0) return;
  const sublists = section.querySelectorAll(".js-media-sublist");
  const popupSlider = section.querySelector(".js-popup-slider");
  const navPrev = section.querySelector(".product-slider-nav-prev");
  const navNext = section.querySelector(".product-slider-nav-next");
  mediaLists.forEach((elem, index) => {
    let slider = new Swiper(elem, {
      slidesPerView: 1,
      spaceBetween: 8,
      autoHeight: false,
      speed: 500,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: navNext,
        prevEl: navPrev,
      },
      thumbs: {
        swiper: sublists.length > 0 ? sublists[index]?.swiper : "",
      },
      on: {
        slideChangeTransitionStart: function () {
          if (sublists.length > 0) {
            sublists[0].swiper.slideTo(elem.swiper.activeIndex);
          }
        },
        slideChange: function () {
          window.pauseAllMedia();
          this.params.noSwiping = false;
          if (popupSlider && popupSlider.swiper) {
            popupSlider.swiper.slideTo(this.activeIndex);
          }
        },
        slideChangeTransitionEnd: function () {
          if (this.slides[this.activeIndex]?.querySelector("model-viewer")) {
            this.slides[this.activeIndex]
              .querySelector(".shopify-model-viewer-ui__button--poster")
              .removeAttribute("hidden");
          }
        },
        touchStart: function () {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            if (
              !this.slides[this.activeIndex]
                .querySelector("model-viewer")
                .classList.contains("shopify-model-viewer-ui__disabled")
            ) {
              this.params.noSwiping = true;
              this.params.noSwipingClass = "swiper-slide";
            } else {
              this.params.noSwiping = false;
            }
          }
        },
      },
    });
  });
};
const subSliderInit = (section) => {
  if (!section) return;
  const sublists = section.querySelectorAll(".js-media-sublist");
  if (sublists.length > 0) {
    sublists.forEach((elem) => {
      const sliderDirection = elem.dataset.thumbsDirection || "vertical";
      let subSlider = new Swiper(elem, {
        spaceBetween: 8,
        slidesPerView: "auto",
        direction: "horizontal",
        freeMode: true,
        allowTouchMove: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        on: {
          touchEnd: function (s, e) {
            let range = 5;
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY);
            if (diff < range || diff > -range) s.allowClick = true;
          },
        },
        breakpoints: {
          990: {
            slidesPerView: "auto",
            direction: sliderDirection,
          },
        },
      });
    });
  }
};
function isIOS() {
  const ua = navigator.userAgent;
  const isIPhone = /iPhone|iPod/.test(ua);
  const isIPad =
    /iPad/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  return isIPhone || isIPad;
}
if (isIOS()) {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.setAttribute(
      "content",
      "width=device-width, initial-scale=1.0, maximum-scale=1.0"
    );
  }
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
const initDetailsAccessibility = () => {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute("role", "button");
    summary.setAttribute("aria-expanded", "false");
    if (summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }
    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });
    if (summary.closest("header-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  });
};
(window.requestIdleCallback || setTimeout)(initDetailsAccessibility);
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  elementToFocus?.focus();
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => {
    if (!video.classList.contains("autoplay-persistent")) {
      video.pause();
    }
  });
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (elementToFocus && !elementToFocus.classList.contains("card-focused"))
    elementToFocus.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });
    this.setMinimumDisable(); // Call once on init
    const eventList = ["paste", "input"];
    for (const event of eventList) {
      this.input.addEventListener(event, (e) => {
        const numberRegex = /^\d*$/; // allows empty string while typing
        const value = e.currentTarget.value;
        if (!numberRegex.test(value)) {
          e.currentTarget.value = 1;
        }
        const currentValue = parseInt(e.currentTarget.value || "0", 10);
        if (currentValue <= this.getMinimumValue()) {
          this.querySelector('button[name="minus"]').setAttribute(
            "disabled",
            ""
          );
        } else {
          this.querySelector('button[name="minus"]').removeAttribute(
            "disabled"
          );
        }
      });
    }
    this.input.addEventListener("focusout", (e) => {
      if (
        e.currentTarget.value === "" ||
        parseInt(e.currentTarget.value, 10) < this.getMinimumValue()
      ) {
        e.currentTarget.value = this.getMinimumValue();
      }
      this.setMinimumDisable();
    });
  }
  getMinimumValue() {
    return 0;
  }
  setMinimumDisable() {
    if (parseInt(this.input.value, 10) <= this.getMinimumValue()) {
      this.querySelector('button[name="minus"]').setAttribute("disabled", "");
    } else {
      this.querySelector('button[name="minus"]').removeAttribute("disabled");
    }
  }
  onButtonClick(event) {
    event.preventDefault();
    const isPlus = event.target.name === "plus";
    const minValue = this.getMinimumValue();
    const currentValue = parseInt(this.input.value || minValue, 10);
    if (isPlus) {
      this.input.stepUp();
    } else {
      if (currentValue > minValue) {
        this.input.stepDown();
      }
    }
    this.setMinimumDisable();
    this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("quantity-input", QuantityInput);
class ProductQuantityInput extends QuantityInput {
  constructor() {
    super();
  }
  getMinimumValue() {
    return 1;
  }
}
customElements.define("product-quantity-input", ProductQuantityInput);
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );
  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    if (!opt) return;
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);
    this.headerWrapper = document.querySelector(".header-wrapper");
    if (this.headerWrapper) this.headerWrapper.preventHide = false;
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button, .mobile-facets__clear").forEach((button) => {
      if (
        this.querySelector(".header__localization-button") === button ||
        this.querySelector(".header__localization-lang-button") === button ||
        button.classList.contains("mobile-facets__footer__button")
      ) {
        return;
      }
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }
  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }
  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }
  openMenuDrawer(summaryElement) {
    if (this.headerWrapper) this.headerWrapper.preventHide = true;
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-drawer`);
  }
  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(`overflow-hidden-drawer`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      if (this.headerWrapper) this.headerWrapper.preventHide = false;
    }
  }
  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(event) {
    document.body.classList.remove("overflow-hidden-drawer");
    const detailsElement = event.currentTarget.closest("details");
    if (!detailsElement) return;
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement?.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".shopify-section-header");
    this.headerWrapper = document.querySelector(".header-wrapper");
    if (this.headerWrapper) this.headerWrapper.preventHide = false;
    this.menuDrawerContainer = this.querySelector(".menu-drawer-container");
    const summaryElements = this.querySelectorAll("summary");
    if (summaryElements && summaryElements.length) {
      this.addAccessibilityAttributes(summaryElements);
    }
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }
  connectedCallback() {
    this.initMobileMegaMenus();
  }
  disconnectedCallback() {}
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    if (detailsElement === this.menuDrawerContainer) {
      if (isOpen) {
        event.preventDefault();
        this.closeMenuDrawer(summaryElement);
      } else {
        this.openMenuDrawer(summaryElement);
      }
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      const ariaExpandedValue =
        summaryElement.getAttribute("aria-expanded") === "true";
      summaryElement.setAttribute("aria-expanded", !ariaExpandedValue);
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }
  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) => {
      summary.addEventListener("click", this.onSummaryClick.bind(this));
    });
    this.querySelectorAll("button").forEach((button) => {
      if (
        this.querySelector(".header__localization-button") === button ||
        this.querySelector(".header__localization-lang-button") === button ||
        button.classList.contains("mobile-facets__footer__button") ||
        button.classList.contains("header__search-close") ||
        button.closest(".mobile-mega-menu-back-button")
      ) {
        return;
      }
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }
  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;
    openDetailsElement === this.menuDrawerContainer
      ? this.closeMenuDrawer(this.menuDrawerContainer.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }
  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.menuDrawerContainer.hasAttribute("open") &&
        !this.menuDrawerContainer.contains(document.activeElement)
      ) {
        const headerSearch = this.querySelector("header-search");
        if (headerSearch && headerSearch.hasAttribute("open")) {
          return;
        }
        this.closeMenuDrawer();
      }
    });
  }
  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    if (!detailsElement) return;
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement?.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
  openMenuDrawer(summaryElement) {
    if (this.headerWrapper) this.headerWrapper.preventHide = true;
    setTimeout(() => {
      this.menuDrawerContainer.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.menuDrawerContainer, summaryElement);
    document.body.classList.add(`overflow-hidden-drawer`);
  }
  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.menuDrawerContainer.classList.remove("menu-opening");
      this.menuDrawerContainer
        .querySelectorAll("details")
        .forEach((details) => {
          details.removeAttribute("open");
          details.classList.remove("menu-opening");
        });
      this.menuDrawerContainer
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(`overflow-hidden-drawer`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.menuDrawerContainer);
      if (this.headerWrapper) this.headerWrapper.preventHide = false;
    }
  }
  initMobileMegaMenus() {
    const mobileTemplates = document.querySelectorAll(
      ".mobile-mega-menu-template"
    );
    const mobileMenuLinks = this.headerWrapper.querySelectorAll(
      ".menu-drawer__menu-link[data-handle]"
    );
    mobileMenuLinks.forEach((link) => {
      const handle = link.dataset.handle;
      const url = link.href;
      const target = link.target;
      const label = link.innerHTML;
      if (!handle) return;
      const template = Array.from(mobileTemplates).find(
        (template) => template.dataset.trigger === handle
      );
      if (!template) return;
      const cloned = template.content.firstElementChild?.cloneNode(true);
      if (!cloned) return;
      const clonedMainLink = cloned.querySelector(
        ".menu-drawer__menu-link--mobile-mega-menu"
      );
      clonedMainLink.href = url;
      clonedMainLink.target = target;
      clonedMainLink.innerHTML = label;
      const parent = link.closest("li");
      parent.innerHTML = "";
      parent.appendChild(cloned);
      const backButton = cloned.querySelector(".mobile-mega-menu-back-button");
      if (backButton) {
        backButton.addEventListener(
          "click",
          this.onCloseButtonClick.bind(this)
        );
      }
      const summary = cloned.querySelector("summary");
      if (summary) {
        summary.addEventListener("click", this.onSummaryClick.bind(this));
      }
      this.initMobileMegaMenuSlider(cloned);
    });
  }
  initMobileMegaMenuSlider(megaMenu) {
    const slider = megaMenu.querySelector(".mobile-mega-menu-slider");
    if (!slider) return;
    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 1000,
      loop: false,
      watchOverflow: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      on: {
        afterInit: () => {
          this.positionMobileMegaMenuSliderNav(slider);
        },
        resize: () => {
          this.positionMobileMegaMenuSliderNav(slider);
        },
      },
      navigation: {
        prevEl: megaMenu.querySelector(
          ".mobile-mega-menu-slider-nav-button--prev"
        ),
        nextEl: megaMenu.querySelector(
          ".mobile-mega-menu-slider-nav-button--next"
        ),
      },
    });
  }
  positionMobileMegaMenuSliderNav(slider) {
    const nav = slider.querySelector(".mobile-mega-menu-slider-nav");
    if (!nav) return;
    const firstSlide = slider.querySelector(".mobile-mega-menu-slide");
    if (!firstSlide) return;
    const imgWrapper = firstSlide.querySelector(
      ".card-small-image-link-wrapper"
    );
    if (!imgWrapper) return;
    const imgRect = imgWrapper.getBoundingClientRect();
    const img = imgWrapper.querySelector("img");
    if (img && !img.complete) {
      img.addEventListener("load", () =>
        this.positionMobileMegaMenuSliderNav(slider)
      );
      return;
    }
    const offsetY = (imgRect.height - nav.offsetHeight) / 2;
    nav.style.top = `${Math.max(offsetY, 0)}px`;
    nav.style.transform = "none";
    nav.classList.add("mobile-mega-menu-slider-nav--visible");
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onClickInside = this.onClickInside.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.animateFollow = this.animateFollow.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);
    this.mouseX = 0;
    this.mouseY = 0;
    this.floatingX = 0;
    this.floatingY = 0;
    this.raf = null;
    this.mediaQuery = window.matchMedia(
      "(pointer: fine) and (min-width: 990px)"
    );
    this.dynamicEnabled = false;
    document.body.appendChild(this);
  }
  connectedCallback() {
    this.dialogEl = this.querySelector('[role="dialog"]');
    this.closeButton = this.querySelector('[id^="ModalClose-"]');
    this.closeButton?.addEventListener("click", this.onCloseClick);
    this.addEventListener("keyup", this.onKeyUp);
    this.addEventListener("click", this.onClickInside);
  }
  disconnectedCallback() {
    this.closeButton?.removeEventListener("click", this.onCloseClick);
    this.removeEventListener("keyup", this.onKeyUp);
    this.removeEventListener("click", this.onClickInside);
    this._disableDynamic();
    this.mediaQuery.removeEventListener("change", this.onMediaChange);
  }
  show(opener, event) {
    this.openedBy = opener;
    this.setAttribute("open", "");
    document.body.classList.add("overflow-hidden");
    window.pauseAllMedia?.();
    this.mediaQuery.addEventListener("change", this.onMediaChange);
    this.onMediaChange(this.mediaQuery);
    if (event && this.dynamicEnabled) {
      this.instantPositionCloseButton(event);
    }
    this.addEventListener(
      "transitionend",
      () => trapFocus(this, this.dialogEl),
      { once: true }
    );
  }
  hide() {
    this.classList.add("closing");
    setTimeout(() => {
      this.removeAttribute("open");
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia?.();
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
      this._disableDynamic();
      this.mediaQuery.removeEventListener("change", this.onMediaChange);
      const mediaContent = document.querySelector(
        ".product-media-modal__content"
      );
      if (mediaContent) {
        mediaContent.classList.remove("zoom");
      }
      this.classList.remove("closing");
    }, 450);
  }
  instantPositionCloseButton(event) {
    if (!this.closeButton) return;
    const offsetX = 32,
      offsetY = 32;
    this.mouseX = event.clientX - offsetX;
    this.mouseY = event.clientY - offsetY;
    this.floatingX = this.mouseX;
    this.floatingY = this.mouseY;
    Object.assign(this.closeButton.style, {
      position: "fixed",
      zIndex: "9999",
      left: `${this.floatingX}px`,
      top: `${this.floatingY}px`,
      pointerEvents: "none",
    });
    const container = this.querySelector(".product-popup-modal__content");
    if (
      !event.target.closest(".product-popup-modal__content-info") &&
      !this.isMouseOverScrollbar(event, container)
    ) {
      this.classList.add("cursor-active");
    } else {
      this.classList.remove("cursor-active");
    }
  }
  onMediaChange(e) {
    if (e.matches && !this.dynamicEnabled) {
      this.dynamicEnabled = true;
      document.addEventListener("mousemove", this.onMouseMove);
      this.raf = requestAnimationFrame(this.animateFollow);
    } else if (!e.matches && this.dynamicEnabled) {
      this._disableDynamic();
    }
  }
  _disableDynamic() {
    if (!this.dynamicEnabled) return;
    document.removeEventListener("mousemove", this.onMouseMove);
    cancelAnimationFrame(this.raf);
    this.dynamicEnabled = false;
    if (this.closeButton) {
      this.closeButton.style.position = "";
      this.closeButton.style.left = "";
      this.closeButton.style.top = "";
      this.closeButton.style.pointerEvents = "";
      this.closeButton.style.zIndex = "";
      this.classList.remove("cursor-active");
    }
  }
  isMouseOverScrollbar(event, container) {
    const rect = container.getBoundingClientRect();
    const hasVertical = container.scrollHeight > container.clientHeight;
    const withinY = event.clientY >= rect.top && event.clientY <= rect.bottom;
    return (
      hasVertical &&
      event.clientX >= rect.left + container.clientWidth &&
      withinY
    );
  }
  onMouseMove(event) {
    if (!this.closeButton) return;
    const offsetX = 32,
      offsetY = 32;
    this.mouseX = event.clientX - offsetX;
    this.mouseY = event.clientY - offsetY;
    const container = this.querySelector(".product-popup-modal__content");
    if (
      !event.target.closest(".product-popup-modal__content-info") &&
      !this.isMouseOverScrollbar(event, container)
    ) {
      this.classList.add("cursor-active");
    } else {
      this.classList.remove("cursor-active");
    }
  }
  animateFollow() {
    if (!this.closeButton) return;
    const ease = 0.25;
    this.floatingX += (this.mouseX - this.floatingX) * ease;
    this.floatingY += (this.mouseY - this.floatingY) * ease;
    Object.assign(this.closeButton.style, {
      position: "fixed",
      zIndex: "9999",
      left: `${this.floatingX}px`,
      top: `${this.floatingY}px`,
      pointerEvents: "none",
    });
    this.raf = requestAnimationFrame(this.animateFollow);
  }
  onKeyUp(event) {
    if (event.code.toUpperCase() === "ESCAPE") {
      this.hide();
    }
  }
  onClickInside(event) {
    if (
      !event.target.closest(".product-popup-modal__content-info") &&
      this.dynamicEnabled
    ) {
      this.onCloseClick(event);
    }
  }
  onCloseClick(e) {
    e.stopPropagation();
    if (!this.closeButton) {
      return this.hide();
    }
    this.closeButton.classList.add("pulse");
    this.hide();
    const done = () => {
      this.closeButton.removeEventListener("animationend", done);
      this.closeButton.classList.remove("pulse");
    };
    this.closeButton.addEventListener("animationend", done);
  }
}
customElements.define("modal-dialog", ModalDialog);
class ProductModal extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }
  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }
  hide() {
    let isOpen = false;
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    document.querySelectorAll("body > quick-add-modal").forEach((el) => {
      if (el.hasAttribute("open")) {
        isOpen = true;
      }
    });
    if (!isOpen) {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
    }
    const images = document.querySelector(".product-media-modal__content");
    if (images) {
      images.classList.remove("zoom");
    }
  }
}
if (!customElements.get("product-modal")) {
  customElements.define("product-modal", ProductModal);
}

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    if (!button) return;
    button.addEventListener("click", (event) => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button, event);
    });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
    if (this.getAttribute("data-autoplay") === "true") {
      this.loadContent();
    }
  }
  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );
      this.setAttribute("loaded", true);
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (
              this.getAttribute("data-autoplay") === "true" &&
              this.closest(".swiper-slide-active")
            ) {
              if (entry.target.nodeName === "VIDEO") {
                let playPromise = entry.target.play();
                if (playPromise !== undefined) {
                  playPromise
                    .then((_) => {})
                    .catch((error) => {
                      console.error("Error playing video:", error);
                    });
                }
              } else if (
                entry.target.nodeName === "IFRAME" &&
                entry.target.contentWindow
              ) {
                if (entry.target.classList.contains("js-youtube")) {
                  entry.target.contentWindow.postMessage(
                    '{"event":"command","func":"playVideo","args":""}',
                    "*"
                  );
                } else {
                  entry.target.contentWindow.postMessage(
                    '{"method":"play"}',
                    "*"
                  );
                }
              }
            }
          } else {
            if (entry.target.nodeName === "VIDEO") {
              entry.target.pause();
            } else if (
              entry.target.nodeName === "IFRAME" &&
              entry.target.contentWindow
            ) {
              if (entry.target.classList.contains("js-youtube")) {
                entry.target.contentWindow.postMessage(
                  '{"event":"command","func":"pauseVideo","args":""}',
                  "*"
                );
              } else {
                entry.target.contentWindow.postMessage(
                  '{"method":"pause"}',
                  "*"
                );
              }
            }
          }
        });
      });
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (
        deferredElement.nodeName === "VIDEO" ||
        deferredElement.nodeName === "IFRAME"
      ) {
        videoObserver.observe(deferredElement);
      }
      if (this.closest(".swiper-slide-active")?.querySelector("model-viewer")) {
        const modelViewer = this.closest(".swiper-slide-active").querySelector(
          "model-viewer"
        );
        if (
          !modelViewer.classList.contains("shopify-model-viewer-ui__disabled")
        ) {
          this.closest(".swiper").swiper.params.noSwiping = true;
          this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
        }
      }
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.isHighVariantNeedUpdate = false;
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "");
    if (!this.currentVariant && this.dataset.isHighVariantProduct === "true") {
      const selectedValuesIds = this.getSelectedValuesIds();
      this.highVariantRequestUrl = this.createRequestUrl({
        selectedValuesIds: selectedValuesIds,
      });
      if (this.highVariantRequestUrl) {
        this.isHighVariantNeedUpdate = true;
      }
    }
    if (this.isHighVariantNeedUpdate === false) {
      this.updatePickupAvailability();
      this.updateVariantStatuses();
    }
    this.cleanErrors();
    if (!this.currentVariant) {
      if (this.isHighVariantNeedUpdate) {
        this.renderProductInfo(this.highVariantRequestUrl);
        return;
      }
      this.toggleAddButton(true, "");
      this.setUnavailable();
    } else {
      if (this.currentVariant?.featured_media) {
        this.updateMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`
        );
      }
      this.updateURL();
      this.updateVariantInput();
      const requestUrl = this.createRequestUrl({
        currentVariantId: this.currentVariant.id,
      });
      this.renderProductInfo(requestUrl);
    }
    const selectedValues = this.getSelectedValues();
    this.setCheckedInputsBySelectedValues(selectedValues);
  }
  cleanErrors() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    if (!productForms || productForms.length === 0) return;
    productForms.forEach((productForm) => {
      const productFormWrapper = productForm.closest(".product-form");
      if (!productFormWrapper) return;
      const errorMessageWrapper = productFormWrapper.querySelector(
        ".product-form__error-message-wrapper"
      );
      if (!errorMessageWrapper) return;
      errorMessageWrapper.setAttribute("hidden", true);
    });
  }
  updateOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll(".product-form__controls--dropdown")
    );
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    ).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      })
    );
  }
  updateMasterId() {
    if (this.variantData || this.querySelector('[type="application/json"]')) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }
  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }
  updateMedia(mediaId) {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const currentSection = document.querySelector(
      `[data-section="main-${this.dataset.section}"]`
    );
    this.mediaList = currentSection.querySelector(".product-media__list");
    const activeMedia = this.mediaList.querySelector(
      `[data-media-id="${mediaId}"]`
    );
    this.mediaList.querySelectorAll("[data-media-id]").forEach((element) => {
      element.classList.remove("active");
    });
    if (activeMedia) activeMedia.classList.add("active");
    const swiperWrappers = document.querySelectorAll(".product-media__wrapper");
    swiperWrappers.forEach((elem) => {
      if (!this.isHidden(elem)) {
        const newMedia = elem.querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );
        if (elem.querySelector(".js-media-list")) {
          elem
            .querySelector(".js-media-list")
            .swiper.slideTo(
              elem
                .querySelector(".js-media-list")
                .swiper.slides.indexOf(newMedia)
            );
        }
      }
    });
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.dataset.section,
        variant: this.currentVariant,
      },
    });
  }
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled", "always-clickable");
          input.disabled = false;
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
          if (this.dataset.unavailableOptionsClickable === "true") {
            input.classList.add("always-clickable");
          } else {
            input.disabled = true;
          }
        }
      }
    });
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }
  renderProductInfo(requestUrl) {
    this.abortController?.abort();
    this.abortController = new AbortController();
    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        try {
          this.setCurrentVariantAfterFetch(html);
        } catch (err) {}
        if (this.isHighVariantNeedUpdate) {
          try {
            this.updateURL();
            this.updatePickupAvailability();
            this.updatePickerInnerHtml(html);
            if (this.currentVariant) {
              this.updateVariantInput();
              if (this.currentVariant.featured_media) {
                const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
                this.updateMedia(mediaId);
              }
            }
          } catch (err) {}
        }
        this.updateElementsAfterFetch(html);
        this.updateVariantSwatches(html);
        if (!this.currentVariant) {
          this.toggleAddButton(true, "");
          this.setUnavailable();
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.info("Fetch aborted by user");
        } else {
          console.error(error);
        }
      });
  }
  toggleAddButton(disable = true, text) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;
    const addButtonText =
      productForm.querySelector('[name="add"] .button__label') ||
      addButton.querySelector("span");
    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) {
        addButtonText.textContent = text;
        addButtonText.setAttribute("data-label", text);
      }
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window?.variantStrings?.addToCart;
      addButtonText.setAttribute(
        "data-label",
        window?.variantStrings?.addToCart
      );
    }
  }
  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    if (!addButton) return;
    this.toggleAddButton(true, window.variantStrings.unavailable);
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-all-variants-no-high]").textContent);
    return this.variantData;
  }
  getSelectedValues() {
    const controls = [...this.querySelectorAll(".product-form__controls")];
    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });
    const selectedValues = controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput ? checkedInput.value : null;
    });
    return selectedValues;
  }
  getSelectedValuesIds() {
    const controls = [...this.querySelectorAll(".product-form__controls")];
    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });
    return controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput?.dataset?.optionValueId
        ? checkedInput.dataset.optionValueId
        : null;
    });
  }
  createRequestUrl({ currentVariantId = "", selectedValuesIds = [] }) {
    const productUrl = `${this.dataset.url}`;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    if (currentVariantId) {
      return `${productUrl}?variant=${currentVariantId}&section_id=${sectionId}`;
    }
    if (selectedValuesIds.length) {
      const params = [];
      params.push(`section_id=${sectionId}`);
      params.push(`option_values=${selectedValuesIds.join(",")}`);
      return `${productUrl}?${params.join("&")}`;
    }
  }
  setCurrentVariantAfterFetch(html) {
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const variantPickerSource = html.getElementById(
      `variant-radios-${sourceSectionId}`
    );
    const variantPickerDestination = document.getElementById(
      `variant-radios-${this.dataset.section}`
    );
    if (!variantPickerSource || !variantPickerDestination) return;
    const newVariantDataEl = variantPickerSource.querySelector(
      "[data-selected-variant]"
    );
    if (!newVariantDataEl) return;
    const newVariantData = variantPickerSource.querySelector(
      "[data-selected-variant]"
    ).innerHTML;
    const selectedVariant = !!newVariantData
      ? JSON.parse(newVariantData)
      : null;
    this.currentVariant = selectedVariant;
    const oldEl = variantPickerDestination.querySelector(
      "[data-selected-variant]"
    );
    if (oldEl) {
      oldEl.innerHTML = newVariantData;
    }
  }
  updateElementsAfterFetch(html) {
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const priceDestination = document.getElementById(
      `price-${currentSectionId}`
    );
    const priceSource = html.getElementById(`price-${sourceSectionId}`);
    if (priceSource && priceDestination) {
      priceDestination.innerHTML = priceSource.innerHTML;
      priceDestination.classList.remove("visibility-hidden");
    }
    const inventorySource = html.getElementById(`Inventory-${sourceSectionId}`);
    const inventoryDestination = document.getElementById(
      `Inventory-${currentSectionId}`
    );
    if (inventorySource && inventoryDestination) {
      inventoryDestination.innerHTML = inventorySource.innerHTML;
      inventoryDestination.classList.toggle(
        "visibility-hidden",
        inventorySource.innerText === ""
      );
    }
    const skuSource = html.getElementById(`Sku-${sourceSectionId}`);
    const skuDestination = document.getElementById(`Sku-${currentSectionId}`);
    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle(
        "visibility-hidden",
        skuSource.classList.contains("visibility-hidden")
      );
    }
    const colorNameSources = html.querySelectorAll(
      `[id^="ColorName-${sourceSectionId}"]`
    );
    const colorNameDestinations = document.querySelectorAll(
      `[id^="ColorName-${currentSectionId}"]`
    );
    if (colorNameSources?.length === colorNameDestinations?.length) {
      colorNameDestinations.forEach((colorNameDestination, index) => {
        colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
      });
    }
  }
  updatePickerInnerHtml(html) {
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const quickAddModal = this.closest("quick-add-modal");
    const variantPickerSource = html.getElementById(
      `variant-radios-${sourceSectionId}`
    );
    const variantPickerDestination = document.getElementById(
      `variant-radios-${currentSectionId}`
    );
    if (variantPickerSource && variantPickerDestination) {
      if (quickAddModal) {
        variantPickerDestination.innerHTML =
          variantPickerSource.innerHTML.replaceAll(
            sourceSectionId,
            `quickadd-${sourceSectionId}`
          );
      } else {
        variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
      }
    }
  }
  updateVariantSwatches(html) {
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const quickAddModal = this.closest("quick-add-modal");
    const variantSwatchesSource = html.querySelector(
      `#variant-radios-${sourceSectionId} [data-is-variant-image-swatch]`
    );
    const variantSwatchesDestination = document.querySelector(
      `#variant-radios-${currentSectionId} [data-is-variant-image-swatch]`
    );
    if (variantSwatchesSource && variantSwatchesDestination) {
      if (quickAddModal) {
        variantSwatchesDestination.innerHTML =
          variantSwatchesSource.innerHTML.replaceAll(
            sourceSectionId,
            `quickadd-${sourceSectionId}`
          );
      } else {
        variantSwatchesDestination.innerHTML = variantSwatchesSource.innerHTML;
      }
    }
  }
  setCheckedInputsBySelectedValues(selectedValues) {
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((groupEl, index) => {
      const selectedValue = selectedValues[index];
      if (!selectedValue) return;
      const inputs = [...groupEl.querySelectorAll('input[type="radio"]')];
      inputs.forEach((input) => {
        const shouldBeChecked = input.value === selectedValue;
        input.checked = shouldBeChecked;
        if (shouldBeChecked) {
          input.setAttribute("checked", "");
        } else {
          input.removeAttribute("checked");
        }
      });
    });
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled", "always-clickable");
        input.disabled = false;
      } else {
        input.classList.add("disabled");
        if (this.dataset.unavailableOptionsClickable === "true") {
          input.classList.add("always-clickable");
        } else {
          input.disabled = true;
        }
      }
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
customElements.define("variant-radios", VariantRadios);
class PasswordViewer {
  constructor() {
    const passwordField = document.querySelectorAll(".field--pass");
    passwordField.forEach((el) => {
      const input = el.querySelector("input");
      const btnWrapper = el.querySelector(".button-pass-visibility");
      const btnOpen = el.querySelector(".icon-eye-close");
      const btnClose = el.querySelector(".icon-eye");
      btnOpen.setAttribute("tabindex", 0);
      btnClose.setAttribute("tabindex", 0);
      input.addEventListener("input", () => {
        input.value !== ""
          ? (btnWrapper.style.display = "block")
          : (btnWrapper.style.display = "none");
      });
      btnOpen.addEventListener("click", () => {
        input.type = "text";
        btnOpen.style.display = "none";
        btnClose.style.display = "block";
      });
      btnOpen.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          input.type = "text";
          btnOpen.style.display = "none";
          btnClose.style.display = "block";
          btnClose.focus();
        }
      });
      btnClose.addEventListener("click", () => {
        input.type = "password";
        btnOpen.style.display = "block";
        btnClose.style.display = "none";
      });
      btnClose.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          input.type = "password";
          btnOpen.style.display = "block";
          btnClose.style.display = "none";
          btnOpen.focus();
        }
      });
    });
  }
}
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest(".product-recommendations-section");
    this.enableAnimation = this.dataset.enableHeaderAnimation === "true";
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.querySelector(".product-recommendations__loading")) {
        this.querySelector(".product-recommendations__loading").classList.add(
          "loading"
        );
        this.querySelector(".product-recommendations__loading").style.display =
          "flex";
      }
      if (this.enableAnimation) {
        this.section.classList.add("anim-active");
      }
      this.recommendationsSlider = null;
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          const updateNavPosition = () => {
            const section = this.closest(".product-recommendations-section");
            if (!section) return;
            const nav = section.querySelector(".product-recommendations-nav");
            if (!nav) return;
            const firstSlide = section.querySelector(
              ".product-recommendations-item"
            );
            if (!firstSlide) return;
            const imgWrapper = firstSlide.querySelector(".card");
            if (!imgWrapper) return;
            const swiperEl = section.querySelector(
              ".product-recommendations-layout"
            );
            const swiperRect = swiperEl.getBoundingClientRect();
            const imgRect = imgWrapper.getBoundingClientRect();
            const offsetTop = imgRect.top - swiperRect.top;
            const centerY = offsetTop + imgRect.height / 2;
            nav.style.top = `${centerY}px`;
          };
          const initSlider = () => {
            const section = this.closest(".product-recommendations-section");
            if (!section) return;
            const swiperEl = this.querySelector(
              ".product-recommendations-layout"
            );
            const swiperWrapper = this.querySelector(
              ".product-recommendations-list"
            );
            const slides = this.querySelectorAll(
              ".product-recommendations-item"
            );
            if (!swiperEl || !swiperWrapper || !slides || !slides.length)
              return;
            swiperEl.classList.add("swiper");
            swiperWrapper.classList.add("swiper-wrapper");
            slides.forEach((slide) => slide.classList.add("swiper-slide"));
            const prevBtn = section.querySelector(
              ".product-recommendations-nav-button--prev"
            );
            const nextBtn = section.querySelector(
              ".product-recommendations-nav-button--next"
            );
            const columns = Number(swiperEl.dataset.columns) || 3;
            const isCenteredSlides = Boolean(swiperEl.dataset.centeredSlides);
            const breakpointsConfig = {
              2: {
                576: { slidesPerView: 2.1, spaceBetween: 20 },
                990: { slidesPerView: 2.1, spaceBetween: 24 },
              },
              3: {
                576: { slidesPerView: 2.1, spaceBetween: 20 },
                990: { slidesPerView: 3.15, spaceBetween: 24 },
              },
              4: {
                576: { slidesPerView: 2.1, spaceBetween: 20 },
                990: { slidesPerView: 3.15, spaceBetween: 24 },
                1360: { slidesPerView: 4.15, spaceBetween: 24 },
              },
            };
            const centeredSlidesBreakpointsConfig = {
              576: { slidesPerView: 1.5, spaceBetween: 20 },
              990: { slidesPerView: 3.15, spaceBetween: 24 },
            };
            const sliderOptions = {
              slidesPerView: 1.15,
              spaceBetween: 16,
              speed: 800,
              allowTouchMove: true,
              centeredSlides: isCenteredSlides,
              centeredSlidesBounds: isCenteredSlides,
              breakpoints: isCenteredSlides
                ? centeredSlidesBreakpointsConfig
                : breakpointsConfig[columns],
              mousewheel: {
                forceToAxis: true,
              },
              a11y: {
                scrollOnFocus: false,
              },
              preventClicks: true,
              navigation:
                nextBtn && prevBtn
                  ? {
                      nextEl: nextBtn,
                      prevEl: prevBtn,
                      disabledClass: "swiper-button-disabled",
                    }
                  : false,
            };
            this.recommendationsSlider = new Swiper(swiperEl, sliderOptions);
            updateNavPosition();
            const nav = section.querySelector(".product-recommendations-nav");
            if (nav) {
              nav.classList.add("product-recommendations-nav--visible");
            }
          };
          const destroySlider = () => {
            if (!this.recommendationsSlider) return;
            const swiperEl = this.querySelector(
              ".product-recommendations-layout"
            );
            const swiperWrapper = this.querySelector(
              ".product-recommendations-list"
            );
            const slides = this.querySelectorAll(
              ".product-recommendations-item"
            );
            if (!swiperEl || !swiperWrapper || !slides || !slides.length)
              return;
            this.recommendationsSlider.destroy(true, true);
            this.recommendationsSlider = null;
            swiperEl.classList.remove("swiper");
            swiperWrapper.classList.remove("swiper-wrapper");
            slides.forEach((slide) => slide.classList.remove("swiper-slide"));
          };
          const initSection = () => {
            const section = this.closest(".product-recommendations-section");
            if (!section) return;
            const desktopLayout = this.dataset.layout;
            const mobileLayout = this.dataset.layoutMobile;
            let currentLayout = null;
            const sectionResizeObserver = new ResizeObserver((entries) => {
              const [entry] = entries;
              let newLayout;
              if (entry.contentRect.width < 576) {
                newLayout = mobileLayout;
              } else {
                newLayout = desktopLayout;
              }
              if (newLayout !== currentLayout) {
                if (this.recommendationsSlider) {
                  destroySlider();
                }
                if (newLayout === "slider") {
                  initSlider();
                }
                currentLayout = newLayout;
              }
              if (currentLayout === "slider") {
                updateNavPosition();
              }
            });
            sectionResizeObserver.observe(section);
          };
          initSection();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.querySelector(".product-recommendations__loading")) {
            this.querySelector(
              ".product-recommendations__loading"
            ).classList.remove("loading");
            this.querySelector(".product-recommendations__loading").remove();
          }
        });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector(".disclosure__list-wrapper"),
    };
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.elements.button.addEventListener("click", this.togglePanel.bind(this));
    this.addEventListener("keydown", this.onEscapePress.bind(this));
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }
  connectedCallback() {
    document.addEventListener("click", this.handleDocumentClick);
  }
  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
  }
  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }
  showPanel() {
    this.elements.button.setAttribute("aria-expanded", "true");
    this.elements.panel.removeAttribute("hidden");
    if (this.hasAttribute("data-header")) {
      this.positionPanel();
    }
  }
  positionPanel() {
    const panel = this.elements.panel;
    const panelRect = panel.getBoundingClientRect();
    const containerRight =
      this.closest(".burger-menu__top")?.getBoundingClientRect().right ||
      document.documentElement.clientWidth;
    if (containerRight - panelRect.right < 16) {
      panel.style.left = "auto";
      panel.style.right = "0";
    }
  }
  togglePanel() {
    if (this.elements.button.getAttribute("aria-expanded") === "true") {
      this.hidePanel();
    } else {
      this.showPanel();
    }
  }
  onEscapePress(event) {
    if (event.key === "Escape") {
      this.hidePanel();
    }
  }
  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    this.querySelector("form")?.submit();
    this.hidePanel();
  }
}
if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}
function slideUp(toggleEl, contentEl, duration = 300) {
  const height = contentEl.clientHeight;
  contentEl.style.transitionProperty = "height, margin, padding";
  contentEl.style.transitionDuration = duration + "ms";
  contentEl.style.overflow = "hidden";
  contentEl.style.height = height + "px";
  contentEl.style.padding = "0";
  contentEl.style.margin = "0";
  setTimeout(function () {
    contentEl.style.height = "0";
    contentEl.style.padding = "0";
    contentEl.style.margin = "0";
  }, 10);
  setTimeout(function () {
    toggleEl.classList.remove("active");
    contentEl.classList.remove("active");
    contentEl.style.removeProperty("height");
    contentEl.style.removeProperty("padding");
    contentEl.style.removeProperty("margin");
    contentEl.style.removeProperty("overflow");
    contentEl.style.removeProperty("transition-duration");
    contentEl.style.removeProperty("transition-property");
  }, duration);
}
function slideDown(toggleEl, contentEl, duration = 300) {
  toggleEl.classList.add("active");
  contentEl.classList.add("active");
  contentEl.style.overflow = "hidden";
  contentEl.style.height = "0";
  const height = contentEl.scrollHeight;
  setTimeout(function () {
    contentEl.style.height = height + "px";
  }, 10);
  setTimeout(function () {
    contentEl.style.removeProperty("overflow");
    contentEl.style.removeProperty("height");
  }, duration);
}
class ProductAdditionalService extends HTMLElement {
  static selectedServices = [];
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.variantId = this.dataset.serviceProductVariantId;
    this.mainProductTitle = this.dataset.mainProductTitle;
    this.productInfo = this.closest(`#ProductInfo-${this.sectionId}`);
    this.dynamicBtns = this.productInfo?.querySelector(
      ".product-form__checkout"
    );
    this.checkbox = this.querySelector("input[type='checkbox']");
    this.checkbox?.addEventListener("change", this.onSelect.bind(this));
  }
  onSelect(event) {
    event.preventDefault();
    const propertyName =
      window.cartStrings?.additional_service_property || "Added with";
    if (this.checkbox.checked) {
      if (
        !ProductAdditionalService.selectedServices.some(
          (item) => item.id === this.variantId
        )
      ) {
        ProductAdditionalService.selectedServices.push({
          id: this.variantId,
          quantity: 1,
          properties: {
            [`${propertyName}`]: this.mainProductTitle,
          },
        });
      }
    } else {
      ProductAdditionalService.selectedServices =
        ProductAdditionalService.selectedServices.filter(
          (item) => item.id !== this.variantId
        );
    }
    if (this.dynamicBtns) {
      this.dynamicBtns.classList.toggle(
        "disabled",
        ProductAdditionalService.selectedServices.length > 0
      );
    }
  }
  getItems(formData) {
    if (!formData || ProductAdditionalService.selectedServices.length === 0) {
      return;
    }
    const mainItemId = formData.get("id");
    const mainItemQuantity = formData.get("quantity");
    if (!mainItemId || !mainItemQuantity) return;
    const additionalItems = ProductAdditionalService.selectedServices.map(
      (service) => {
        return {
          id: service.id,
          quantity: service.quantity,
          properties: service.properties,
        };
      }
    );
    const mainProperties = {};
    for (const [key, value] of formData.entries()) {
      if (key.startsWith("properties[")) {
        const cleanKey = key.replace(/^properties\[(.*?)\]$/, "$1");
        mainProperties[cleanKey] = value;
      }
    }
    return [
      ...additionalItems,
      {
        id: mainItemId,
        quantity: mainItemQuantity,
        properties: mainProperties,
      },
    ];
  }
  clearItems() {
    ProductAdditionalService.selectedServices = [];
  }
}
if (!customElements.get("product-additional-service")) {
  customElements.define("product-additional-service", ProductAdditionalService);
}
(function () {
  function isMobileTapDevice() {
    if (!window.matchMedia) return false;
    return window.matchMedia('(hover: none), (pointer: coarse)').matches;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-mobile-image-tap-link]');

    if (!link || !isMobileTapDevice()) return;

    var cardWrapper = link.closest('.card-wrapper');
    if (!cardWrapper) return;

    var hasSecondImage = cardWrapper.querySelector(
      '.card--hover-secondary_image .card-media > img + img, .card--hover-secondary_image .card-media > .placeholder-svg + .placeholder-svg'
    );

    if (!hasSecondImage) return;

    if (cardWrapper.classList.contains('is-mobile-image-open')) return;

    event.preventDefault();

    document.querySelectorAll('.card-wrapper.is-mobile-image-open').forEach(function (openCard) {
      if (openCard !== cardWrapper) openCard.classList.remove('is-mobile-image-open');
    });

    cardWrapper.classList.add('is-mobile-image-open');
  });
})();

/* Product-card image gallery: hover image 2, then arrows/swipe through all images. */
(function () {
  var legacyCardObserver = null;
  var globalSwipeGallery = null;
  var globalSwipePointerId = null;
  var globalSwipeStartX = 0;
  var globalSwipeStartY = 0;

  function addGalleryControls(gallery, count) {
    if (!gallery.querySelector('[data-card-gallery-prev]')) {
      var previousButton = document.createElement('button');
      previousButton.type = 'button';
      previousButton.className = 'herbz-card-gallery__arrow herbz-card-gallery__arrow--prev';
      previousButton.setAttribute('data-card-gallery-prev', '');
      previousButton.setAttribute('aria-label', 'Forrige billede');
      previousButton.innerHTML = '<span aria-hidden="true">‹</span>';
      gallery.appendChild(previousButton);
    }

    if (!gallery.querySelector('[data-card-gallery-next]')) {
      var nextButton = document.createElement('button');
      nextButton.type = 'button';
      nextButton.className = 'herbz-card-gallery__arrow herbz-card-gallery__arrow--next';
      nextButton.setAttribute('data-card-gallery-next', '');
      nextButton.setAttribute('aria-label', 'Næste billede');
      nextButton.innerHTML = '<span aria-hidden="true">›</span>';
      gallery.appendChild(nextButton);
    }

    var counter = gallery.querySelector('[data-card-gallery-counter]');
    if (!counter) {
      counter = document.createElement('div');
      counter.className = 'herbz-card-gallery__counter';
      counter.setAttribute('data-card-gallery-counter', '');
      counter.setAttribute('aria-live', 'polite');
      gallery.appendChild(counter);
    }
    counter.textContent = '1 / ' + count;
  }

  function normaliseImageUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.pathname.replace(/_\d+x\d*(?=\.[a-z]+$)/i, '');
    } catch (error) {
      return String(url || '').split('?')[0];
    }
  }

  async function prepareLegacyCardGallery(card) {
    if (!card || card.dataset.cardGalleryLoading === 'true') return;

    var gallery = card.querySelector('.card-media');
    var handle = card.dataset.product;
    if (!gallery || !handle) return;

    if (gallery.hasAttribute('data-card-gallery')) {
      initCardGallery(gallery);
      return;
    }

    card.dataset.cardGalleryLoading = 'true';

    try {
      var response = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;

      var product = await response.json();
      var variantImageUrls = new Set(
        (Array.isArray(product.variants) ? product.variants : []).map(function (variant) {
          var featuredImage = variant && variant.featured_image;
          var source = featuredImage && typeof featuredImage === 'object' ? featuredImage.src : featuredImage;
          return normaliseImageUrl(source || '');
        }).filter(Boolean)
      );
      var imageUrls = (Array.isArray(product.images) ? product.images : []).filter(function (url, index) {
        // Product image 1 is the visual cover and must remain first even when
        // Shopify also assigns it to a variant. Other variant-only images stay hidden.
        return index === 0 || !variantImageUrls.has(normaliseImageUrl(url));
      }).slice(0, 7);
      if (imageUrls.length < 2) return;

      var existingImages = Array.from(gallery.querySelectorAll('img'));
      var existingByUrl = new Map();
      existingImages.forEach(function (image) {
        existingByUrl.set(normaliseImageUrl(image.currentSrc || image.src), image);
      });

      var orderedImages = imageUrls.map(function (url, index) {
        var image = existingByUrl.get(normaliseImageUrl(url));
        if (!image) {
          image = document.createElement('img');
          image.src = url;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.alt = product.title || card.dataset.productTitle || '';
          gallery.appendChild(image);
        }

        image.classList.add('motion-reduce', 'herbz-card-gallery__image');
        image.classList.toggle('media--first', index === 0);
        image.classList.toggle('media--second', index === 1);
        image.classList.toggle('media--gallery-extra', index > 1);
        return image;
      });

      existingImages.forEach(function (image) {
        if (!orderedImages.includes(image)) image.style.display = 'none';
      });

      gallery.setAttribute('data-card-gallery', '');
      gallery.setAttribute('data-card-gallery-count', String(orderedImages.length));
      gallery.setAttribute('aria-roledescription', 'carousel');
      gallery.setAttribute('aria-label', 'Produktbilleder for ' + (product.title || card.dataset.productTitle || 'produkt'));
      addGalleryControls(gallery, orderedImages.length);
      initCardGallery(gallery);
    } catch (error) {
      console.warn('[Herbz card gallery] Kunne ikke hente produktbilleder', error);
    } finally {
      card.dataset.cardGalleryLoading = 'false';
    }
  }

  function initCardGallery(gallery) {
    if (!gallery || gallery.dataset.cardGalleryReady === 'true') return;

    var images = Array.from(gallery.querySelectorAll('.herbz-card-gallery__image'));
    if (images.length < 2) return;

    var card = gallery.closest('product-card');
    if (card) card.classList.add('has-card-gallery');
    var counter = gallery.querySelector('[data-card-gallery-counter]');
    var currentIndex = 0;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchActive = false;
    var suppressNextClick = false;

    gallery.dataset.cardGalleryReady = 'true';
    gallery.dataset.galleryIndex = '0';

    images.forEach(function (image, index) {
      image.classList.toggle('is-gallery-current', index === 0);
      image.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
    });

    function hydrateGalleryImage(image) {
      if (!image || !image.dataset.gallerySrc) return;
      image.src = image.dataset.gallerySrc;
      image.removeAttribute('data-gallery-src');
    }

    function render(index, interacting) {
      currentIndex = (index + images.length) % images.length;
      hydrateGalleryImage(images[currentIndex]);
      gallery.dataset.galleryIndex = String(currentIndex);
      gallery.classList.toggle('is-gallery-interacting', interacting !== false);

      images.forEach(function (image, imageIndex) {
        image.classList.toggle('is-gallery-current', imageIndex === currentIndex);
        image.setAttribute('aria-hidden', imageIndex === currentIndex ? 'false' : 'true');
      });

      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + images.length;
    }

    function visualIndexBeforeInteraction() {
      var hasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (!gallery.classList.contains('is-gallery-interacting') && hasFinePointer && gallery.matches(':hover')) {
        return 1;
      }
      return currentIndex;
    }

    function move(direction) {
      render(visualIndexBeforeInteraction() + direction, true);
    }

    gallery.herbzGalleryMove = move;

    function blockFollowingCardClick() {
      suppressNextClick = true;
      gallery.dataset.gallerySuppressClickUntil = String(Date.now() + 650);
      window.setTimeout(function () { suppressNextClick = false; }, 680);
    }

    function completeSwipe(deltaX, deltaY) {
      if (Math.abs(deltaX) < 38 || Math.abs(deltaX) <= Math.abs(deltaY)) return false;
      blockFollowingCardClick();
      move(deltaX < 0 ? 1 : -1);
      return true;
    }

    var previousButton = gallery.querySelector('[data-card-gallery-prev]');
    var nextButton = gallery.querySelector('[data-card-gallery-next]');

    if (previousButton) {
      previousButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        move(-1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        move(1);
      });
    }

    if (!('PointerEvent' in window)) {
      gallery.addEventListener('touchstart', function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        touchActive = true;
      }, { passive: true });

      gallery.addEventListener('touchend', function (event) {
        if (!touchActive || !event.changedTouches || !event.changedTouches.length) return;
        touchActive = false;
        completeSwipe(
          event.changedTouches[0].clientX - touchStartX,
          event.changedTouches[0].clientY - touchStartY
        );
      }, { passive: true });
    }

    gallery.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    gallery.addEventListener('click', function (event) {
      if (!suppressNextClick) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  function initCardGalleries(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.card-media[data-card-gallery]').forEach(initCardGallery);
    scope.querySelectorAll('product-card').forEach(function (card) {
      if (card.querySelector('.card-media[data-card-gallery]')) return;
      if (legacyCardObserver) legacyCardObserver.observe(card);
      else prepareLegacyCardGallery(card);
    });
  }

  function bootCardGalleries() {
    if ('IntersectionObserver' in window) {
      legacyCardObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          legacyCardObserver.unobserve(entry.target);
          prepareLegacyCardGallery(entry.target);
        });
      }, { rootMargin: '320px 0px' });
    }

    initCardGalleries(document);

    document.addEventListener('pointerdown', function (event) {
      var arrow = event.target.closest && event.target.closest('[data-card-gallery-prev], [data-card-gallery-next]');

      if (event.pointerType === 'mouse' && arrow) {
        var arrowGallery = arrow.closest('.card-media[data-card-gallery]');
        if (arrowGallery && typeof arrowGallery.herbzGalleryMove === 'function') {
          arrowGallery.herbzGalleryMove(arrow.hasAttribute('data-card-gallery-next') ? 1 : -1);
          arrow.dataset.galleryHandledAt = String(Date.now());
        }
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        return;
      }

      if (event.pointerType === 'mouse' || globalSwipePointerId !== null) return;

      var card = event.target.closest && event.target.closest('product-card');
      var gallery = card && card.querySelector('.card-media[data-card-gallery][data-card-gallery-ready="true"]');
      if (!gallery || typeof gallery.herbzGalleryMove !== 'function') return;

      globalSwipeGallery = gallery;
      globalSwipePointerId = event.pointerId;
      globalSwipeStartX = event.clientX;
      globalSwipeStartY = event.clientY;
    }, true);

    document.addEventListener('pointerup', function (event) {
      if (!globalSwipeGallery || globalSwipePointerId !== event.pointerId) return;

      var gallery = globalSwipeGallery;
      var deltaX = event.clientX - globalSwipeStartX;
      var deltaY = event.clientY - globalSwipeStartY;
      globalSwipeGallery = null;
      globalSwipePointerId = null;

      if (Math.abs(deltaX) < 38 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

      gallery.dataset.gallerySuppressClickUntil = String(Date.now() + 700);
      gallery.herbzGalleryMove(deltaX < 0 ? 1 : -1);
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }, true);

    document.addEventListener('pointercancel', function (event) {
      if (globalSwipePointerId !== event.pointerId) return;
      globalSwipeGallery = null;
      globalSwipePointerId = null;
    }, true);

    document.addEventListener('click', function (event) {
      var arrow = event.target.closest && event.target.closest('[data-card-gallery-prev], [data-card-gallery-next]');
      var gallery = event.target.closest && event.target.closest('.card-media[data-card-gallery]');
      var suppressUntil = gallery ? Number(gallery.dataset.gallerySuppressClickUntil || 0) : 0;

      if (!arrow && !gallery) return;

      if (!arrow && gallery && Date.now() > suppressUntil) {
        var card = gallery.closest('product-card');
        var productLink = card && card.querySelector('.card-link-overlay[href], .card__title a[href]');

        if (productLink && productLink.href) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          window.location.assign(productLink.href);
        }
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      if (arrow && gallery && typeof gallery.herbzGalleryMove === 'function') {
        var handledAt = Number(arrow.dataset.galleryHandledAt || 0);
        if (Date.now() - handledAt > 650) {
          gallery.herbzGalleryMove(arrow.hasAttribute('data-card-gallery-next') ? 1 : -1);
        }
        return;
      }

    }, true);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.card-media[data-card-gallery]')) initCardGallery(node);
          if (node.matches && node.matches('product-card')) {
            if (legacyCardObserver) legacyCardObserver.observe(node);
            else prepareLegacyCardGallery(node);
          }
          initCardGalleries(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCardGalleries, { once: true });
  } else {
    bootCardGalleries();
  }
})();
(function () {
  function cleanMoneySpanText(root) {
    var scope = root || document;
    var cartAreas = scope.querySelectorAll
      ? scope.querySelectorAll('cart-drawer, .cart-drawer, #CartDrawer, .drawer, .cart, [id*="Cart"], [class*="cart"]')
      : [];

    cartAreas.forEach(function (cartArea) {
      var elements = cartArea.querySelectorAll('*');

      elements.forEach(function (element) {
        if (element.children.length) return;

        var text = element.textContent;
        if (!text || text.indexOf('<span') === -1 || text.indexOf('money') === -1) return;

        element.textContent = text
          .replace(/<span[^>]*class=['"]?money['"]?[^>]*>/gi, '')
          .replace(/<\/span>/gi, '');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    cleanMoneySpanText(document);
  });

  document.addEventListener('cart:updated', function () {
    cleanMoneySpanText(document);
  });

  document.addEventListener('cart:refresh', function () {
    cleanMoneySpanText(document);
  });

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData' && mutation.target.parentElement) {
        cleanMoneySpanText(mutation.target.parentElement);
      }

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) cleanMoneySpanText(node);
      });
    });
  }).observe(document.body || document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();

(function () {
  var translations = {
    da: { chooseVariant: 'Vælg variant', popular: 'Populær', save: 'Spar', bestValue: 'Bedste værdi' },
    en: { chooseVariant: 'Choose variant', popular: 'Popular', save: 'Save', bestValue: 'Best value' },
    fr: { chooseVariant: 'Choisir une variante', popular: 'Populaire', save: 'Économisez', bestValue: 'Meilleur choix' },
    de: { chooseVariant: 'Variante wählen', popular: 'Beliebt', save: 'Spare', bestValue: 'Bestes Angebot' },
    es: { chooseVariant: 'Elegir variante', popular: 'Popular', save: 'Ahorra', bestValue: 'Mejor opción' },
    sv: { chooseVariant: 'Välj variant', popular: 'Populär', save: 'Spara', bestValue: 'Bäst värde' },
    it: { chooseVariant: 'Scegli variante', popular: 'Popolare', save: 'Risparmia', bestValue: 'Miglior valore' },
    cs: { chooseVariant: 'Vybrat variantu', popular: 'Oblíbené', save: 'Ušetříte', bestValue: 'Nejlepší hodnota' }
  };

  window.getHerbzVariantTranslations = function () {
    var language = String(document.documentElement.lang || 'da').toLowerCase().split('-')[0];
    return translations[language] || translations.da;
  };
})();

(function () {
  function parseGrams(value) {
    var normalized = String(value || '').replace(',', '.');
    var match = normalized.match(/(\d+(?:\.\d+)?)\s*g\b/i);

    return match ? Number(match[1]) : null;
  }

  function getVariantGrams(variant) {
    return (
      parseGrams(variant.title) ||
      parseGrams(variant.option1) ||
      parseGrams(variant.option2) ||
      parseGrams(variant.option3)
    );
  }

  function getDataContext(script) {
    return (
      script.closest('product-card') ||
      script.closest('product-info') ||
      script.closest('.quick-add-modal') ||
      script.closest('quick-add-modal') ||
      script.closest('.product') ||
      script.closest('.shopify-section') ||
      script.parentElement ||
      document
    );
  }

  function getCleanText(element) {
    var clone = element.cloneNode(true);

    clone.querySelectorAll('.variant-popular-badge, .variant-savings-badge, .variant-best-value-badge').forEach(function (badge) {
      badge.remove();
    });

    return clone.textContent.replace(/\u00a0/g, ' ').trim();
  }

  function matchesGrams(element, grams) {
    var text = getCleanText(element);
    var escapedGrams = String(grams).replace('.', '[,.]');
    var pattern = new RegExp('(^|[^0-9])' + escapedGrams + '\\s*g\\b', 'i');

    return pattern.test(text);
  }

  function addBadge(element, className, html) {
    if (element.querySelector('.' + className)) return;

    var badge = document.createElement('span');
    badge.className = className;
    badge.innerHTML = html;
    element.appendChild(badge);
  }

  function getSavingsData(script) {
    try {
      var data = JSON.parse(script.textContent);
      var variants = (data.variants || [])
        .map(function (variant) {
          var grams = getVariantGrams(variant);
          if (!grams) return null;

          return {
            id: String(variant.id),
            grams: grams,
            price: Number(variant.price),
            pricePerGram: Number(variant.price) / grams
          };
        })
        .filter(Boolean);

      var baseline = variants.find(function (variant) {
        return Math.abs(variant.grams - 10) < 0.001;
      });

      if (!baseline || !baseline.pricePerGram) return null;

      variants.forEach(function (variant) {
        variant.savingPercent = Math.round((1 - variant.pricePerGram / baseline.pricePerGram) * 100);
        variant.isPopular = Math.abs(variant.grams - 20) < 0.001;
      });

      var bestValue = variants
        .filter(function (variant) {
          return variant.grams > 10 && variant.savingPercent > 0;
        })
        .sort(function (a, b) {
          return a.pricePerGram - b.pricePerGram;
        })[0];

      return {
        variants: variants,
        bestValueId: bestValue ? bestValue.id : null
      };
    } catch (error) {
      return null;
    }
  }

  function enhanceSelectOptions(context, variant) {
    var labels = window.getHerbzVariantTranslations();
    context.querySelectorAll('select[name="id"] option').forEach(function (option) {
      if (String(option.value) !== variant.id) return;

      if (!option.dataset.variantSavingsOriginalText) {
        option.dataset.variantSavingsOriginalText = option.textContent.trim();
      }

      var text = option.dataset.variantSavingsOriginalText;

      if (variant.isPopular) {
        text += ' - ' + labels.popular;
      }

      if (variant.grams > 10 && variant.savingPercent > 0) {
        text += ' - ' + labels.save + ' ' + variant.savingPercent + '%';
      }

      if (variant.isBestValue) {
        text += ' - ' + labels.bestValue;
      }

      option.textContent = text;
      option.dataset.variantSavingsText = 'true';
    });
  }

  function enhanceCustomCardDropdown(context, variant) {
    var labels = window.getHerbzVariantTranslations();
    context.querySelectorAll('[data-card-custom-variant-option][data-variant-id]').forEach(function (option) {
      if (String(option.dataset.variantId) !== variant.id) return;

      var badgeArea = option.querySelector('.card-variant-custom__badges');

      if (!badgeArea) {
        badgeArea = document.createElement('span');
        badgeArea.className = 'card-variant-custom__badges';
        option.appendChild(badgeArea);
      }

      if (variant.isPopular && !badgeArea.querySelector('.card-variant-custom__badge--popular')) {
        var popularBadge = document.createElement('span');
        popularBadge.className = 'card-variant-custom__badge card-variant-custom__badge--popular';
        popularBadge.textContent = labels.popular;
        badgeArea.appendChild(popularBadge);
      }

      if (variant.grams > 10 && variant.savingPercent > 0 && !badgeArea.querySelector('.card-variant-custom__badge--saving')) {
        var savingBadge = document.createElement('span');
        savingBadge.className = 'card-variant-custom__badge card-variant-custom__badge--saving';
        savingBadge.textContent = '\u2193 ' + variant.savingPercent + '%';
        badgeArea.appendChild(savingBadge);
      }

      if (variant.isBestValue && !badgeArea.querySelector('.card-variant-custom__badge--best')) {
        var bestBadge = document.createElement('span');
        bestBadge.className = 'card-variant-custom__badge card-variant-custom__badge--best';
        bestBadge.textContent = labels.bestValue;
        badgeArea.appendChild(bestBadge);
      }
    });
  }

  function enhanceButtonsAndLabels(context, variant) {
    var labels = window.getHerbzVariantTranslations();
    var optionElements = context.querySelectorAll(
      [
        'variant-radios label',
        'variant-selects label',
        '.product-form__controls-group label',
        '.product-form__input label',
        '.product-form__controls-group button',
        'button[role="option"]',
        '[role="option"]'
      ].join(',')
    );

    optionElements.forEach(function (element) {
      if (element.closest('[data-card-custom-variant-option]')) return;
      if (!matchesGrams(element, variant.grams)) return;

      element.classList.add('variant-savings-pill');

      if (variant.isPopular) {
        addBadge(element, 'variant-popular-badge', labels.popular);
      }

      if (variant.grams > 10 && variant.savingPercent > 0) {
        addBadge(element, 'variant-savings-badge', '<span aria-hidden="true">&#8595;</span> ' + variant.savingPercent + '%');
      }

      if (variant.isBestValue) {
        addBadge(element, 'variant-best-value-badge', labels.bestValue);
      }
    });
  }

  function enhanceVariantSavings(root) {
    var scope = root || document;
    var scripts = scope.querySelectorAll
      ? scope.querySelectorAll('[data-variant-savings-json]')
      : [];

    scripts.forEach(function (script) {
      var savingsData = getSavingsData(script);
      if (!savingsData) return;

      var context = getDataContext(script);

      savingsData.variants.forEach(function (variant) {
        variant.isBestValue = savingsData.bestValueId === variant.id;

        enhanceSelectOptions(context, variant);
        enhanceCustomCardDropdown(context, variant);
        enhanceButtonsAndLabels(context, variant);
      });
    });
  }

  function scheduleEnhance(root) {
    enhanceVariantSavings(root || document);

    window.clearTimeout(window.__variantSavingsGlobalTimer);
    window.__variantSavingsGlobalTimer = window.setTimeout(function () {
      enhanceVariantSavings(document);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleEnhance(document);
    });
  } else {
    scheduleEnhance(document);
  }

  window.setTimeout(function () {
    scheduleEnhance(document);
  }, 900);

  document.addEventListener('shopify:section:load', function (event) {
    scheduleEnhance(event.target);
  });

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      var shouldRun = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (
            node.matches('[data-variant-savings-json], product-card, product-info, quick-add-modal, .quick-add-modal, variant-radios, variant-selects') ||
            node.querySelector('[data-variant-savings-json], product-card, product-info, quick-add-modal, .quick-add-modal, variant-radios, variant-selects')
          ) {
            shouldRun = true;
          }
        });
      });

      if (shouldRun) {
        scheduleEnhance(document);
      }
    }).observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();



(function () {
  function closeDropdown(dropdown) {
    if (!dropdown) return;

    var toggle = dropdown.querySelector('[data-card-custom-variant-toggle]');

    dropdown.classList.remove('is-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function closeAllDropdowns(exceptDropdown) {
    document.querySelectorAll('[data-card-custom-variant].is-open').forEach(function (dropdown) {
      if (dropdown !== exceptDropdown) {
        closeDropdown(dropdown);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-card-custom-variant-toggle]');

    if (toggle) {
      var dropdown = toggle.closest('[data-card-custom-variant]');
      if (!dropdown || toggle.disabled) return;

      var shouldOpen = !dropdown.classList.contains('is-open');

      closeAllDropdowns(dropdown);
      dropdown.classList.toggle('is-open', shouldOpen);
      toggle.setAttribute('aria-expanded', String(shouldOpen));

      return;
    }

    var option = event.target.closest('[data-card-custom-variant-option]');

    if (option) {
      var optionDropdown = option.closest('[data-card-custom-variant]');
      var form = option.closest('form');

      if (!optionDropdown || !form || option.disabled || option.getAttribute('aria-disabled') === 'true') return;

      var input = form.querySelector('[data-card-custom-variant-input]');
      var submit = form.querySelector('[data-card-variant-native-submit]');
      var label = optionDropdown.querySelector('[data-card-custom-variant-label]');
      var title = option.querySelector('.card-variant-custom__title');

      if (input) {
        input.value = option.dataset.variantId || '';
      }

      if (label && title) {
        label.textContent = title.textContent.trim();
      }

      closeDropdown(optionDropdown);

      if (input && input.value && submit) {
        submit.click();
      }

      return;
    }

    if (!event.target.closest('[data-card-custom-variant]')) {
      closeAllDropdowns();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllDropdowns();
    }
  });
})();



(function () {
  if (window.__cardVariantTopLayerPortalFixLoaded) return;
  window.__cardVariantTopLayerPortalFixLoaded = true;

  var activePortal = null;
  var portalPositionQueued = false;
  var portalPositionEventsBound = false;

  function getToggle(dropdown) {
    return dropdown ? dropdown.querySelector('[data-card-custom-variant-toggle]') : null;
  }

  function getMenu(dropdown) {
    return dropdown ? dropdown.querySelector('[data-card-custom-variant-menu]') : null;
  }

  function getDefaultLabel(dropdown) {
    var toggle = getToggle(dropdown);
    var labels = window.getHerbzVariantTranslations
      ? window.getHerbzVariantTranslations()
      : { chooseVariant: 'Vælg variant' };
    return toggle && toggle.dataset.defaultLabel ? toggle.dataset.defaultLabel : labels.chooseVariant;
  }

  function restorePortalMenu() {
    if (!activePortal || !activePortal.menu) return;

    activePortal.menu.classList.remove('card-variant-custom__menu--portal');
    activePortal.menu.style.removeProperty('--card-variant-portal-top');
    activePortal.menu.style.removeProperty('--card-variant-portal-left');
    activePortal.menu.style.removeProperty('--card-variant-portal-width');

    if (activePortal.placeholder && activePortal.placeholder.parentNode) {
      activePortal.placeholder.parentNode.insertBefore(activePortal.menu, activePortal.placeholder);
      activePortal.placeholder.parentNode.removeChild(activePortal.placeholder);
    }

    activePortal = null;
    unbindPortalPositionEvents();
  }

  function closeDropdown(dropdown) {
    if (!dropdown) return;

    if (activePortal && activePortal.dropdown === dropdown) {
      restorePortalMenu();
    }

    dropdown.classList.remove('is-open');

    var toggle = getToggle(dropdown);
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function closeAllDropdowns(exceptDropdown) {
    document.querySelectorAll('[data-card-custom-variant].is-open').forEach(function (dropdown) {
      if (dropdown !== exceptDropdown) {
        closeDropdown(dropdown);
      }
    });

    if (activePortal && activePortal.dropdown !== exceptDropdown) {
      closeDropdown(activePortal.dropdown);
    }
  }

  function positionPortalMenu() {
    portalPositionQueued = false;

    if (!activePortal || !activePortal.toggle || !activePortal.menu) return;

    var rect = activePortal.toggle.getBoundingClientRect();
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    var width = Math.min(Math.max(rect.width * 1.18, 210), Math.max(viewportWidth - 16, 210), 280);
    var left = rect.left + rect.width / 2 - width / 2;
    var top = rect.bottom + 7;

    left = Math.max(8, Math.min(left, viewportWidth - width - 8));

    activePortal.menu.style.setProperty('--card-variant-portal-top', top + 'px');
    activePortal.menu.style.setProperty('--card-variant-portal-left', left + 'px');
    activePortal.menu.style.setProperty('--card-variant-portal-width', width + 'px');
  }

  function schedulePortalPosition() {
    if (!activePortal || portalPositionQueued) return;

    portalPositionQueued = true;
    window.requestAnimationFrame(positionPortalMenu);
  }

  function bindPortalPositionEvents() {
    if (portalPositionEventsBound) return;

    portalPositionEventsBound = true;
    window.addEventListener('scroll', schedulePortalPosition, true);
    window.addEventListener('resize', schedulePortalPosition);
  }

  function unbindPortalPositionEvents() {
    if (!portalPositionEventsBound) return;

    portalPositionEventsBound = false;
    window.removeEventListener('scroll', schedulePortalPosition, true);
    window.removeEventListener('resize', schedulePortalPosition);
  }

  function openDropdown(dropdown) {
    var toggle = getToggle(dropdown);
    var menu = getMenu(dropdown);

    if (!dropdown || !toggle || !menu || toggle.disabled) return;

    closeAllDropdowns(dropdown);

    var placeholder = document.createComment('card variant dropdown portal');
    menu.parentNode.insertBefore(placeholder, menu);
    document.body.appendChild(menu);

    activePortal = {
      dropdown: dropdown,
      toggle: toggle,
      menu: menu,
      placeholder: placeholder
    };

    dropdown.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    menu.classList.add('card-variant-custom__menu--portal');

    bindPortalPositionEvents();
    positionPortalMenu();
    schedulePortalPosition();
  }

  function resetDropdownLabel(dropdown) {
    var label = dropdown ? dropdown.querySelector('[data-card-custom-variant-label]') : null;

    if (label) {
      label.textContent = getDefaultLabel(dropdown);
    }
  }

  function handleOption(option) {
    if (!activePortal || !activePortal.dropdown) return;
    if (option.disabled || option.getAttribute('aria-disabled') === 'true' || option.classList.contains('is-disabled')) return;

    var dropdown = activePortal.dropdown;
    var form = dropdown.closest('form');
    if (!form) return;

    var input = form.querySelector('[data-card-custom-variant-input]');
    var submit = form.querySelector('[data-card-variant-native-submit]');

    if (input) {
      input.value = option.dataset.variantId || '';
    }

    activePortal.menu.querySelectorAll('[data-card-custom-variant-option].is-selected').forEach(function (selectedOption) {
      selectedOption.classList.remove('is-selected');
    });

    option.classList.add('is-selected');
    resetDropdownLabel(dropdown);
    closeDropdown(dropdown);

    if (input && input.value && submit) {
      submit.click();
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-card-custom-variant-toggle]');

    if (toggle) {
      var dropdown = toggle.closest('[data-card-custom-variant]');
      if (!dropdown || toggle.disabled) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (activePortal && activePortal.dropdown === dropdown && dropdown.classList.contains('is-open')) {
        closeDropdown(dropdown);
      } else {
        openDropdown(dropdown);
      }

      return;
    }

    var option = event.target.closest('[data-card-custom-variant-option]');

    if (option && activePortal && activePortal.menu && activePortal.menu.contains(option)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      handleOption(option);
      return;
    }

    if (activePortal && !event.target.closest('[data-card-custom-variant]') && !activePortal.menu.contains(event.target)) {
      closeDropdown(activePortal.dropdown);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activePortal) {
      event.stopImmediatePropagation();
      closeDropdown(activePortal.dropdown);
    }
  }, true);

})();


(function () {
  if (window.__globalAddToCartScrollFixLoaded) return;
  window.__globalAddToCartScrollFixLoaded = true;

  var lock = null;
  var nativeFocus = HTMLElement.prototype.focus;

  function isCartRelated(element) {
    return Boolean(
      element &&
      element.closest &&
      element.closest('cart-drawer, cart-notification, .cart-drawer, #CartDrawer, .cart-notification, #cart-notification')
    );
  }

  HTMLElement.prototype.focus = function (options) {
    if (lock && isCartRelated(this)) {
      return nativeFocus.call(this, Object.assign({}, options || {}, { preventScroll: true }));
    }

    return nativeFocus.call(this, options);
  };

  function isBuyNowTarget(target) {
    return Boolean(
      target &&
      target.closest &&
      target.closest('.shopify-payment-button, .shopify-payment-button__button, [data-shopify="payment-button"]')
    );
  }

  function isAddToCartTarget(target) {
    if (!target || !target.closest) return false;
    if (isBuyNowTarget(target)) return false;

    return Boolean(target.closest('form[action*="/cart/add"]'));
  }

  function rememberScroll() {
    lock = {
      x: window.pageXOffset || document.documentElement.scrollLeft || 0,
      y: window.pageYOffset || document.documentElement.scrollTop || 0,
      until: Date.now() + 650
    };

    restoreScroll();
    [0, 16, 50, 100, 180, 320, 520].forEach(function (delay) {
      window.setTimeout(restoreScroll, delay);
    });
  }

  function restoreScroll() {
    if (!lock) return;

    if (Date.now() > lock.until) {
      lock = null;
      return;
    }

    if (window.pageXOffset !== lock.x || window.pageYOffset !== lock.y) {
      window.scrollTo(lock.x, lock.y);
    }
  }

  function preventCartFocusScroll(event) {
    if (!lock) return;

    if (isCartRelated(event.target)) {
      restoreScroll();
    }
  }

  function releaseScrollLock() {
    lock = null;
  }

  function releaseScrollLockFromKeyboard(event) {
    if (!lock) return;

    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].indexOf(event.key) !== -1) {
      releaseScrollLock();
    }
  }

  document.addEventListener('click', function (event) {
    if (isAddToCartTarget(event.target)) {
      rememberScroll();
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
      var submitter = event.submitter || document.activeElement;

      if (!isBuyNowTarget(submitter)) {
        rememberScroll();
      }
    }
  }, true);

  document.addEventListener('focusin', preventCartFocusScroll, true);
  window.addEventListener('wheel', releaseScrollLock, { passive: true, capture: true });
  window.addEventListener('touchmove', releaseScrollLock, { passive: true, capture: true });
  document.addEventListener('keydown', releaseScrollLockFromKeyboard, true);

  [
    'cart:refresh',
    'cart:updated',
    'cart:change',
    'cart:open',
    'cart-drawer:open',
    'theme:cart:open',
    'ajaxProduct:added'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, restoreScroll, true);
    window.addEventListener(eventName, restoreScroll, true);
  });
})();






/* HERBZ PREMIUM QUICKVIEW SYNC V15 */
(function () {
  if (window.__herbzPremiumQuickviewSync) return;
  window.__herbzPremiumQuickviewSync = true;

  var pageCache = new Map();
  var prefetchedProductUrls = new Set();
  var syncTimers = new WeakMap();
  var retryCounts = new WeakMap();

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function normalizeUrl(url) {
    if (!url) return '';

    try {
      var normalized = new URL(url, window.location.origin);
      var currentUrl = new URL(window.location.href);
      var quickviewParams = [
        'section_id',
        'sections',
        'option_values'
      ];
      var previewParams = [
        'preview_theme_id',
        '_ab',
        '_fd',
        '_sc',
        'pb',
        'design_theme_id',
        'surface_inter_position',
        'surface_intra_position',
        'surface_type'
      ];

      quickviewParams.forEach(function (key) {
        normalized.searchParams.delete(key);
      });

      previewParams.forEach(function (key) {
        if (currentUrl.searchParams.has(key) && !normalized.searchParams.has(key)) {
          normalized.searchParams.set(key, currentUrl.searchParams.get(key));
        }
      });

      normalized.hash = '';
      return normalized.href;
    } catch (error) {
      return '';
    }
  }

  function pushUnique(list, url) {
    if (url && list.indexOf(url) === -1) {
      list.push(url);
    }
  }

  function isQuickviewView(view) {
    if (!view) return false;

    return /quick|card|modal/i.test(view);
  }

  function withSearchParam(url, callback) {
    var normalized = normalizeUrl(url);

    if (!normalized) return '';

    try {
      var parsed = new URL(normalized);
      callback(parsed);
      parsed.hash = '';
      return parsed.href;
    } catch (error) {
      return '';
    }
  }

  function getProductPageUrls(productUrl) {
    var urls = [];
    var normalized = normalizeUrl(productUrl);

    if (!normalized) return urls;

    pushUnique(urls, normalized);

    try {
      var parsed = new URL(normalized);
      var currentUrl = new URL(window.location.href);
      var view = parsed.searchParams.get('view');
      var currentView = currentUrl.searchParams.get('view');

      if (isQuickviewView(view)) {
        pushUnique(
          urls,
          withSearchParam(normalized, function (candidate) {
            candidate.searchParams.delete('view');
          })
        );
      }

      if (currentView && !isQuickviewView(currentView) && (!view || isQuickviewView(view))) {
        pushUnique(
          urls,
          withSearchParam(normalized, function (candidate) {
            candidate.searchParams.set('view', currentView);
          })
        );
      }

      if (!view || isQuickviewView(view)) {
        pushUnique(
          urls,
          withSearchParam(normalized, function (candidate) {
            candidate.searchParams.set('view', 'extended');
          })
        );
      }
    } catch (error) {
      return urls;
    }

    return urls;
  }

  function getProductUrlFromElement(element) {
    if (!element || !element.closest) return '';

    var trigger = element.closest('[data-product-url]');

    if (trigger && trigger.getAttribute('data-product-url')) {
      return trigger.getAttribute('data-product-url');
    }

    var opener = element.closest('modal-opener[data-modal]');

    if (opener) {
      var openerTrigger = opener.querySelector('[data-product-url]');

      if (openerTrigger && openerTrigger.getAttribute('data-product-url')) {
        return openerTrigger.getAttribute('data-product-url');
      }
    }

    var productCard = element.closest('product-card, .card-wrapper, .card');
    var productLink = productCard ? productCard.querySelector('a[href*="/products/"]') : null;

    if (productLink) {
      return productLink.href || productLink.getAttribute('href') || '';
    }

    var directLink = element.closest('a[href*="/products/"]');
    return directLink ? directLink.href || directLink.getAttribute('href') || '' : '';
  }

  function prewarmProductPage(productUrl, immediate) {
    var normalized = normalizeUrl(productUrl);

    if (!normalized || prefetchedProductUrls.has(normalized)) return;

    prefetchedProductUrls.add(normalized);

    var warm = function () {
      fetchProductPage(normalized).catch(function () {
        prefetchedProductUrls.delete(normalized);
      });
    };

    if (immediate) {
      warm();
    } else if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warm, { timeout: 900 });
    } else {
      window.setTimeout(warm, 90);
    }
  }

  function getProductUrlFromModal(modal) {
    if (!modal) return '';

    if (modal.dataset.qvProductUrl) {
      return modal.dataset.qvProductUrl;
    }

    if (modal.openedBy) {
      if (modal.openedBy.getAttribute && modal.openedBy.getAttribute('data-product-url')) {
        return modal.openedBy.getAttribute('data-product-url');
      }

      var openedByProductUrl = modal.openedBy.closest ? modal.openedBy.closest('[data-product-url]') : null;

      if (openedByProductUrl) {
        return openedByProductUrl.getAttribute('data-product-url') || '';
      }

      var openedByParent = modal.openedBy.closest ? modal.openedBy.closest('modal-opener[data-modal]') : null;
      var openedByButton = openedByParent ? openedByParent.querySelector('[data-product-url]') : null;

      if (openedByButton) {
        return openedByButton.getAttribute('data-product-url') || '';
      }
    }

    if (modal.id) {
      var openerSelector = '#' + modal.id;
      var openers = document.querySelectorAll('modal-opener[data-modal]');

      for (var i = 0; i < openers.length; i += 1) {
        if (openers[i].getAttribute('data-modal') === openerSelector) {
          var openerButton = openers[i].querySelector('[data-product-url]');

          if (openerButton) {
            return openerButton.getAttribute('data-product-url') || '';
          }
        }
      }
    }

    var productLink = modal.querySelector('a[href*="/products/"]');
    return productLink ? productLink.href : '';
  }

  function getOpenerForModal(modal) {
    if (!modal) return null;

    if (modal.openedBy) {
      return modal.openedBy;
    }

    if (!modal.id) return null;

    var openers = document.querySelectorAll('modal-opener[data-modal="#' + modal.id + '"]');
    var opener = openers.length ? openers[0] : null;

    return opener ? opener.querySelector('[data-product-url]') || opener : null;
  }

  function getProductCardForModal(modal) {
    var opener = getOpenerForModal(modal);

    if (!opener || !opener.closest) return null;

    return opener.closest('product-card, .card-wrapper, .card');
  }

  function getImageCandidateSource(image) {
    if (!image) return '';

    return (
      image.getAttribute('data-ppb-current-image-url') ||
      image.getAttribute('data-src') ||
      image.getAttribute('src') ||
      image.currentSrc ||
      ''
    );
  }

  function getImageCandidateSrcset(image) {
    if (!image) return '';

    return (
      image.getAttribute('data-ppb-current-srcset') ||
      image.getAttribute('data-srcset') ||
      image.getAttribute('srcset') ||
      ''
    );
  }

  function getBestQuickviewImage(modal, builder) {
    var builderImage = builder ? builder.querySelector('.premium-product-builder__main-image') : null;

    if (builderImage && getImageCandidateSource(builderImage)) {
      return builderImage;
    }

    var modalImage = modal.querySelector('.product-media-item img, .product__media img, .product-media img, img[src*="/products/"]');

    if (modalImage && getImageCandidateSource(modalImage)) {
      return modalImage;
    }

    var card = getProductCardForModal(modal);
    var cardImage = card ? card.querySelector('img') : null;

    if (cardImage && getImageCandidateSource(cardImage)) {
      return cardImage;
    }

    return null;
  }

  function ensureQuickviewMedia(modal, builder) {
    if (!modal) return;

    var frame = modal.querySelector('.product-media__list-wrapper, .product-media__wrapper, .product-media, .product__media-wrapper, .product__media-list');

    if (!frame) return;

    var sourceImage = getBestQuickviewImage(modal, builder);
    var imageSrc = getImageCandidateSource(sourceImage);

    if (!imageSrc) return;

    frame.querySelectorAll('[data-qv-premium-media]').forEach(function (element) {
      element.remove();
    });

    var wrapper = document.createElement('div');
    wrapper.className = 'quickview-premium-media';
    wrapper.setAttribute('data-qv-premium-media', '');

    var image = document.createElement('img');
    image.className = 'quickview-premium-media__image';
    image.src = imageSrc;
    image.alt = sourceImage.getAttribute('alt') || '';
    image.loading = 'eager';
    image.decoding = 'async';

    if ('fetchPriority' in image) {
      image.fetchPriority = 'high';
    }

    var srcset = getImageCandidateSrcset(sourceImage);

    if (srcset) {
      image.setAttribute('srcset', srcset);
      image.setAttribute('sizes', 'min(42rem, 70vw)');
    }

    wrapper.appendChild(image);
    frame.appendChild(wrapper);
    modal.classList.add('has-qv-premium-media');
  }

  function updateQuickviewLayoutMode(modal) {
    if (!modal) return;

    var content = modal.querySelector('.quick-add-modal__content');
    var width = content ? content.getBoundingClientRect().width : window.innerWidth;
    var compact = width > 0 ? width <= 520 : window.innerWidth <= 760;

    modal.classList.toggle('is-qv-compact', compact);
  }

  function beginQuickviewPreparing(modal) {
    if (!modal) return;

    modal.classList.remove('is-premium-synced', 'is-premium-fallback', 'has-qv-premium-media', 'has-qv-premium-options', 'is-qv-compact');
    modal.classList.add('is-qv-preparing');
    window.clearTimeout(modal.__qvPreparingTimer);
    modal.__qvPreparingTimer = window.setTimeout(function () {
      modal.classList.remove('is-qv-preparing');
    }, 1800);
  }

  function finishQuickviewPreparing(modal) {
    if (!modal) return;

    window.clearTimeout(modal.__qvPreparingTimer);
    modal.classList.remove('is-qv-preparing');
    updateQuickviewLayoutMode(modal);
  }

  function getFallbackVariants(modal) {
    var card = getProductCardForModal(modal);
    var script = card ? card.querySelector('[data-product-card-variants]') : null;

    if (!script) return [];

    try {
      return JSON.parse(script.textContent || '[]').map(function (variant) {
        return {
          id: variant.id,
          available: variant.available,
          options: variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean),
          title: variant.title,
          price: variant.price,
          priceText: formatMoney(variant.price),
          compareAtPrice: variant.compare_at_price || variant.compareAtPrice || 0,
          compareAtPriceText: variant.compare_at_price || variant.compareAtPrice ? formatMoney(variant.compare_at_price || variant.compareAtPrice) : ''
        };
      });
    } catch (error) {
      return [];
    }
  }

  function fetchProductPage(productUrl) {
    var urls = getProductPageUrls(productUrl);
    var cacheKey = urls.join('|');

    if (!urls.length) {
      return Promise.reject(new Error('Missing quickview product URL'));
    }

    if (!pageCache.has(cacheKey)) {
      pageCache.set(
        cacheKey,
        urls.reduce(function (chain, url) {
          return chain.then(function (bestResult) {
            if (bestResult && bestResult.builder) return bestResult;

            return fetch(url, {
              credentials: 'same-origin',
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
              .then(function (response) {
                if (!response.ok) throw new Error('Could not load product page');
                return response.text();
              })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var builder = doc.querySelector('.premium-product-builder');

                return {
                  document: doc,
                  builder: builder,
                  url: url
                };
              })
              .catch(function () {
                return bestResult;
              });
          });
        }, Promise.resolve(null)).then(function (result) {
          return result || {
            document: null,
            builder: null,
            url: urls[0]
          };
        })
      );
    }

    return pageCache.get(cacheKey);
  }

  function cloneClean(source) {
    if (!source) return null;

    var clone = source.cloneNode(true);

    clone.querySelectorAll('script, style').forEach(function (element) {
      element.remove();
    });

    clone.querySelectorAll('[id]').forEach(function (element) {
      element.removeAttribute('id');
    });

    clone.querySelectorAll('[form]').forEach(function (element) {
      element.removeAttribute('form');
    });

    clone.querySelectorAll('input, select, textarea').forEach(function (input) {
      input.disabled = true;
      input.removeAttribute('name');
    });

    return clone;
  }

  function appendClone(parent, source, extraClass) {
    var clone = cloneClean(source);

    if (!clone) return null;

    if (extraClass) {
      clone.classList.add(extraClass);
    }

    parent.appendChild(clone);
    return clone;
  }

  function insertAfter(reference, node, fallbackParent) {
    if (reference && reference.parentNode) {
      reference.parentNode.insertBefore(node, reference.nextSibling);
      return;
    }

    fallbackParent.appendChild(node);
  }

  function insertBefore(reference, node, fallbackParent) {
    if (reference && reference.parentNode) {
      reference.parentNode.insertBefore(node, reference);
      return;
    }

    fallbackParent.appendChild(node);
  }

  function normalizeOptionValue(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(',', '.');
  }

  function getNativeOptionGroups(modal) {
    if (!modal) return [];

    return Array.prototype.slice.call(
      modal.querySelectorAll('.product-parameters .product-form__controls, .product-parameters .product-form__input, variant-radios .product-form__input, variant-selects .product-form__input')
    );
  }

  function selectNativeOption(modal, index, value) {
    var groups = getNativeOptionGroups(modal);
    var group = groups[index];
    var targetValue = normalizeOptionValue(value);

    if (!group || !targetValue) return false;

    var select = group.querySelector('select');

    if (select) {
      var option = Array.prototype.slice.call(select.options).find(function (item) {
        return normalizeOptionValue(item.value || item.textContent) === targetValue;
      });

      if (option) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    var inputs = Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]'));
    var matchedInput = inputs.find(function (input) {
      var label = group.querySelector('label[for="' + input.id + '"]');
      var labelText = label ? label.textContent : '';

      return normalizeOptionValue(input.value) === targetValue || normalizeOptionValue(labelText) === targetValue;
    });

    if (matchedInput) {
      if (!matchedInput.checked) {
        matchedInput.click();
      }

      matchedInput.checked = true;
      matchedInput.dispatchEvent(new Event('change', { bubbles: true }));
      matchedInput.dispatchEvent(new Event('input', { bubbles: true }));
      return true;
    }

    return false;
  }

  function syncQuickviewOptionState(modal) {
    var selectedValues = getSelectedOptionValues(modal);

    modal.querySelectorAll('[data-qv-option]').forEach(function (option) {
      var index = Number(option.getAttribute('data-option-index') || 0);
      var value = option.getAttribute('data-option-value');
      var isSelected = normalizeOptionValue(selectedValues[index]) === normalizeOptionValue(value);

      option.classList.toggle('is-selected', isSelected);
      option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function buildQuickviewOptions(modal, builder, params, buyButtons, info) {
    var sourceOptions = builder ? builder.querySelector('.premium-product-builder__options') : null;

    if (!sourceOptions) return null;

    var slot = document.createElement('div');
    slot.className = 'quickview-premium-slot quickview-premium-slot--options';
    slot.setAttribute('data-qv-premium', '');

    var optionsClone = cloneClean(sourceOptions);

    if (!optionsClone) return null;

    /* The full product page may contain a merch size guide inside the options
       container. Quick View only needs the option buttons, so never clone the
       guide into the modal. */
    optionsClone.querySelectorAll('.premium-product-builder__size-guide').forEach(function (sizeGuide) {
      sizeGuide.remove();
    });

    optionsClone.querySelectorAll('[data-ppb-option]').forEach(function (button) {
      button.setAttribute('type', 'button');
      button.setAttribute('data-qv-option', '');
      button.setAttribute('aria-pressed', button.classList.contains('is-selected') ? 'true' : 'false');
    });

    slot.appendChild(optionsClone);
    insertBefore(params || buyButtons || info.lastElementChild, slot, info);
    modal.classList.add('has-qv-premium-options');

    return slot;
  }

  function copyThemeVars(modal, builder) {
    if (!modal || !builder) return;

    var map = {
      '--ppb-bg': '--qv-bg',
      '--ppb-panel': '--qv-panel',
      '--ppb-media-bg': '--qv-panel-soft',
      '--ppb-text': '--qv-text',
      '--ppb-muted': '--qv-muted',
      '--ppb-accent': '--qv-accent',
      '--ppb-button-bg': '--qv-button-bg',
      '--ppb-button-text': '--qv-button-text',
      '--ppb-radius': '--qv-radius'
    };

    Object.keys(map).forEach(function (sourceVar) {
      var value = builder.style.getPropertyValue(sourceVar);

      if (value && value.trim()) {
        modal.style.setProperty(map[sourceVar], value.trim());
      }
    });

    var accent = builder.style.getPropertyValue('--ppb-accent');

    if (accent && accent.trim()) {
      modal.style.setProperty('--qv-border', 'color-mix(in srgb, ' + accent.trim() + ' 42%, transparent)');
    }
  }

  function getVariants(builder) {
    var script = builder ? builder.querySelector('[data-ppb-variants]') : null;

    if (!script) return [];

    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function getCurrentVariantId(modal) {
    var variantInput = modal.querySelector('form[action*="/cart/add"] [name="id"], product-form form [name="id"]');

    if (variantInput && variantInput.value) {
      return String(variantInput.value);
    }

    return '';
  }

  function getSelectedOptionValues(modal) {
    var values = [];
    var groups = modal.querySelectorAll('.product-form__controls, .product-form__input');

    groups.forEach(function (group) {
      var checked = group.querySelector('input[type="radio"]:checked, option:checked');

      if (checked) {
        values.push(checked.value);
      }
    });

    return values;
  }

  function findCurrentVariant(modal) {
    var variants = modal.__qvPremiumVariants || [];
    var id = getCurrentVariantId(modal);

    if (id) {
      var byId = variants.find(function (variant) {
        return String(variant.id) === String(id);
      });

      if (byId) return byId;
    }

    var selectedOptions = getSelectedOptionValues(modal);

    if (selectedOptions.length) {
      return variants.find(function (variant) {
        return selectedOptions.every(function (value, index) {
          return String(variant.options[index]) === String(value);
        });
      }) || null;
    }

    return variants[0] || null;
  }

  function getGrams(variant) {
    if (!variant) return 0;

    var text = '';

    if (variant.options) {
      text += variant.options.join(' ') + ' ';
    }

    if (variant.title) {
      text += variant.title;
    }

    var match = text.match(/(\d+(?:[.,]\d+)?)\s*g(?:ram)?\b/i);

    return match ? Number(match[1].replace(',', '.')) : 0;
  }

  function formatMoney(cents) {
    var currency = 'DKK';

    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      currency = window.Shopify.currency.active;
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'da-DK', {
        style: 'currency',
        currency: currency
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return (Number(cents || 0) / 100).toFixed(2) + ' ' + currency;
    }
  }

  function shouldShowCompare(variant) {
    var grams = getGrams(variant);
    var compareAt = Number(variant && variant.compareAtPrice ? variant.compareAtPrice : 0);
    var price = Number(variant && variant.price ? variant.price : 0);

    if (!compareAt || compareAt <= price) return false;
    if (grams && Math.abs(grams - 10) < 0.001) return false;

    return true;
  }

  function getGramPriceText(variant) {
    var grams = getGrams(variant);

    if (!grams || !variant || !variant.price) return '';

    return formatMoney(Math.round(Number(variant.price) / grams)) + ' pr. g';
  }

  function enhanceSubmitButton(modal) {
    var submitButton = modal.querySelector('.product-form__submit');

    if (!submitButton || submitButton.dataset.qvPremiumSubmit === 'true') return;

    submitButton.dataset.qvPremiumSubmit = 'true';
    submitButton.classList.add('quickview-premium-submit');

    var priceWrap = document.createElement('span');
    priceWrap.className = 'quickview-premium-submit__prices';
    priceWrap.setAttribute('data-qv-submit-prices', '');
    priceWrap.innerHTML = '<span data-qv-submit-price></span><s data-qv-submit-compare hidden></s>';

    var gramPrice = document.createElement('span');
    gramPrice.className = 'quickview-premium-submit__gram';
    gramPrice.setAttribute('data-qv-submit-gram', '');
    gramPrice.hidden = true;

    var spinner = submitButton.querySelector('.loading-overlay__spinner');

    if (spinner && spinner.parentNode === submitButton) {
      submitButton.insertBefore(priceWrap, spinner);
      submitButton.insertBefore(gramPrice, spinner);
    } else {
      submitButton.appendChild(priceWrap);
      submitButton.appendChild(gramPrice);
    }
  }

  function updateDynamicText(modal) {
    var variant = findCurrentVariant(modal);

    if (!variant) return;

    var gramText = getGramPriceText(variant);
    var gramElement = modal.querySelector('[data-qv-gram-price]');

    if (gramElement) {
      gramElement.textContent = gramText;
      gramElement.hidden = !gramText;
    }

    enhanceSubmitButton(modal);

    var submitPrice = modal.querySelector('[data-qv-submit-price]');
    var submitCompare = modal.querySelector('[data-qv-submit-compare]');
    var submitGram = modal.querySelector('[data-qv-submit-gram]');

    if (submitPrice) {
      submitPrice.textContent = variant.priceText || formatMoney(variant.price);
    }

    if (submitCompare) {
      submitCompare.textContent = shouldShowCompare(variant) ? (variant.compareAtPriceText || formatMoney(variant.compareAtPrice)) : '';
      submitCompare.hidden = !shouldShowCompare(variant);
    }

    if (submitGram) {
      submitGram.textContent = gramText;
      submitGram.hidden = !gramText;
    }

    syncQuickviewOptionState(modal);

    modal.querySelectorAll('.quickview-premium-plan-readonly[data-plan-type="bundle"]').forEach(function (plan) {
      var bundlePrice = Number(plan.dataset.bundleVariantPrice || 0);
      var discountPercent = Number(plan.dataset.bundleDiscountPercent || 0);
      var combined = Number(variant.price || 0) + bundlePrice;
      var discounted = Math.round(combined * (100 - discountPercent) / 100);
      var bundlePriceElement = plan.querySelector('[data-ppb-bundle-price]');
      var bundleCompareElement = plan.querySelector('[data-ppb-bundle-compare]');

      if (bundlePriceElement) {
        bundlePriceElement.textContent = formatMoney(discounted);
      }

      if (bundleCompareElement) {
        bundleCompareElement.textContent = formatMoney(combined);
      }
    });
  }

  function buildPremiumBlocks(modal, builder, productUrl) {
    var info = modal.querySelector('.product-info-container, .product__info-container, .product__info-wrapper, .product__info, product-info');

    if (!info || !builder) return false;

    info.querySelectorAll('[data-qv-premium]').forEach(function (element) {
      element.remove();
    });

    modal.querySelectorAll('[data-qv-premium-modal]').forEach(function (element) {
      element.remove();
    });

    var title = info.querySelector('.product-title, .product__title, h1, h2');
    var price = info.querySelector('.product-price, .price, .product__price');
    var tax = info.querySelector('.product-tax');
    var params = info.querySelector('.product-parameters, variant-radios, variant-selects, .product-form__input');
    var buyButtons = info.querySelector('.product-buy-buttons, product-form, .product-form');

    var topSlot = document.createElement('div');
    topSlot.className = 'quickview-premium-slot quickview-premium-slot--top';
    topSlot.setAttribute('data-qv-premium', '');

    appendClone(topSlot, builder.querySelector('.premium-product-builder__thca-strength'));

    if (topSlot.children.length) {
      insertAfter(title, topSlot, info);
    }

    var priceSlot = document.createElement('div');
    priceSlot.className = 'quickview-premium-slot quickview-premium-slot--price';
    priceSlot.setAttribute('data-qv-premium', '');

    var gramPrice = document.createElement('div');
    gramPrice.className = 'premium-product-builder__gram-price quickview-premium-gram-price';
    gramPrice.setAttribute('data-qv-gram-price', '');
    gramPrice.hidden = true;
    priceSlot.appendChild(gramPrice);

    appendClone(priceSlot, builder.querySelector('.premium-product-builder__info-link'));

    if (priceSlot.children.length) {
      insertAfter(price, priceSlot, info);
    }

    var infoModal = cloneClean(builder.querySelector('[data-ppb-info-modal]'));

    if (infoModal) {
      infoModal.setAttribute('data-qv-premium-modal', '');
      infoModal.hidden = true;
      modal.appendChild(infoModal);
    }

    var highlightsSlot = document.createElement('div');
    highlightsSlot.className = 'quickview-premium-slot quickview-premium-slot--highlights';
    highlightsSlot.setAttribute('data-qv-premium', '');

    appendClone(highlightsSlot, builder.querySelector('.premium-product-builder__highlights'));

    if (highlightsSlot.children.length) {
      insertAfter(tax || priceSlot || price, highlightsSlot, info);
    }

    buildQuickviewOptions(modal, builder, params, buyButtons, info);

    var paymentSlot = document.createElement('div');
    paymentSlot.className = 'quickview-premium-slot quickview-premium-slot--payments';
    paymentSlot.setAttribute('data-qv-premium', '');

    appendClone(paymentSlot, builder.querySelector('.premium-product-builder__payment-icons'));

    if (paymentSlot.children.length) {
      insertAfter(buyButtons || params || info.lastElementChild, paymentSlot, info);
    }

    var detailsLink = modal.querySelector('a[href*="/products/"]');

    if (detailsLink && productUrl) {
      detailsLink.href = productUrl;
    }

    return true;
  }

  function buildFallbackBlocks(modal) {
    var info = modal.querySelector('.product-info-container, .product__info-container, .product__info-wrapper, .product__info, product-info');
    var card = getProductCardForModal(modal);

    if (!info || !card) return false;

    var title = info.querySelector('.product-title, .product__title, h1, h2');
    var price = info.querySelector('.product-price, .price, .product__price');
    var details = card.querySelector('.card-product-details');

    info.querySelectorAll('[data-qv-premium]').forEach(function (element) {
      element.remove();
    });

    if (details) {
      var detailSlot = document.createElement('div');
      detailSlot.className = 'quickview-premium-slot quickview-premium-slot--top quickview-premium-card-details';
      detailSlot.setAttribute('data-qv-premium', '');
      detailSlot.appendChild(cloneClean(details));
      insertAfter(title, detailSlot, info);
    }

    var priceSlot = document.createElement('div');
    priceSlot.className = 'quickview-premium-slot quickview-premium-slot--price';
    priceSlot.setAttribute('data-qv-premium', '');

    var gramPrice = document.createElement('div');
    gramPrice.className = 'premium-product-builder__gram-price quickview-premium-gram-price';
    gramPrice.setAttribute('data-qv-gram-price', '');
    gramPrice.hidden = true;
    priceSlot.appendChild(gramPrice);
    insertAfter(price, priceSlot, info);

    return true;
  }

  function syncModal(modal) {
    if (!modal) return;

    var productUrl = getProductUrlFromModal(modal);

    if (!productUrl) {
      var urlRetryCount = retryCounts.get(modal) || 0;

      if (modal.hasAttribute('open') && urlRetryCount < 18) {
        retryCounts.set(modal, urlRetryCount + 1);
        scheduleSync(modal, 180);
      }

      return;
    }

    fetchProductPage(productUrl)
      .then(function (result) {
        var builder = result.builder;

        if (!builder) {
          var fallbackInfo = modal.querySelector('.product-info-container, .product__info-container, .product__info-wrapper, .product__info, product-info');

          if (!fallbackInfo) {
            var fallbackCount = retryCounts.get(modal) || 0;

            if (fallbackCount < 18) {
              retryCounts.set(modal, fallbackCount + 1);
              scheduleSync(modal, 180);
            }

            return;
          }

          modal.__qvPremiumVariants = getFallbackVariants(modal);

          if (!fallbackInfo.querySelector('[data-qv-premium]')) {
            buildFallbackBlocks(modal);
          }

          updateDynamicText(modal);
          ensureQuickviewMedia(modal, null);
          modal.classList.add('is-premium-synced', 'is-premium-fallback');
          finishQuickviewPreparing(modal);
          return;
        }

        var info = modal.querySelector('.product-info-container, .product__info-container, .product__info-wrapper, .product__info, product-info');

        if (!info) {
          var count = retryCounts.get(modal) || 0;

          if (count < 18) {
            retryCounts.set(modal, count + 1);
            scheduleSync(modal, 180);
          }

          return;
        }

        var syncedUrl = normalizeUrl(productUrl);
        var hasPremiumBlocks = Boolean(info.querySelector('[data-qv-premium]'));

        retryCounts.set(modal, 0);
        modal.__qvPremiumVariants = getVariants(builder);
        copyThemeVars(modal, builder);

        if (modal.dataset.qvSyncedUrl !== syncedUrl || !hasPremiumBlocks) {
          buildPremiumBlocks(modal, builder, productUrl);
          modal.dataset.qvSyncedUrl = syncedUrl;
        }

        updateDynamicText(modal);
        ensureQuickviewMedia(modal, builder);
        modal.classList.add('is-premium-synced');
        finishQuickviewPreparing(modal);
      })
      .catch(function () {
        modal.classList.remove('is-premium-synced');
        finishQuickviewPreparing(modal);
      });
  }

  function scheduleSync(modal, delay) {
    if (!modal) return;

    window.clearTimeout(syncTimers.get(modal));

    syncTimers.set(
      modal,
      window.setTimeout(function () {
        syncModal(modal);
      }, typeof delay === 'number' ? delay : 120)
    );
  }

  function scheduleOpenModals(delay) {
    document.querySelectorAll('quick-add-modal[open], quick-add-modal.is-open, quick-add-modal.active, .quick-add-modal[open], .quick-add-modal.is-open, .quick-add-modal.active').forEach(function (modal) {
      scheduleSync(modal, delay);
    });
  }

  onReady(function () {
    var lastWarmElement = null;
    var lastWarmAt = 0;

    var warmQuickview = function (event) {
      var warmTarget = event.target && event.target.closest
        ? event.target.closest('modal-opener[data-modal], [data-product-url], product-card, .card-wrapper, .card, a[href*="/products/"]')
        : null;

      if (!warmTarget) return;

      var now = Date.now();

      if (warmTarget === lastWarmElement && now - lastWarmAt < 700) {
        return;
      }

      lastWarmElement = warmTarget;
      lastWarmAt = now;

      var productUrl = getProductUrlFromElement(warmTarget);

      if (productUrl) {
        prewarmProductPage(productUrl, event.type === 'touchstart');
      }
    };

    document.addEventListener('pointerover', warmQuickview, { passive: true });
    document.addEventListener('focusin', warmQuickview);
    document.addEventListener('touchstart', warmQuickview, { passive: true });

    document.addEventListener(
      'click',
      function (event) {
        var opener = event.target.closest('modal-opener[data-modal]');

        if (!opener) return;

        var trigger = event.target.closest('[data-product-url]') || opener.querySelector('[data-product-url]');
        var productUrl = trigger ? trigger.getAttribute('data-product-url') : '';
        var modalSelector = opener.getAttribute('data-modal');
        var modal = modalSelector ? document.querySelector(modalSelector) : null;

        if (modal && productUrl) {
          modal.dataset.qvProductUrl = productUrl;
          prewarmProductPage(productUrl, true);
          beginQuickviewPreparing(modal);
          scheduleSync(modal, 80);
          window.setTimeout(function () {
            scheduleSync(modal, 0);
          }, 420);
          window.setTimeout(function () {
            scheduleSync(modal, 0);
          }, 900);
        }
      },
      true
    );

    document.addEventListener('change', function (event) {
      var modal = event.target.closest('quick-add-modal, .quick-add-modal');

      if (!modal || !modal.classList.contains('is-premium-synced')) return;

      window.setTimeout(function () {
        updateDynamicText(modal);
      }, 80);
      window.setTimeout(function () {
        updateDynamicText(modal);
      }, 360);
    });

    document.addEventListener('click', function (event) {
      var modal = event.target.closest('quick-add-modal, .quick-add-modal');

      if (!modal) return;

      var qvOption = event.target.closest('[data-qv-option]');

      if (qvOption) {
        event.preventDefault();
        event.stopPropagation();

        var optionIndex = Number(qvOption.getAttribute('data-option-index') || 0);
        var optionValue = qvOption.getAttribute('data-option-value');

        if (selectNativeOption(modal, optionIndex, optionValue)) {
          modal.querySelectorAll('[data-qv-option][data-option-index="' + optionIndex + '"]').forEach(function (item) {
            var isSelected = normalizeOptionValue(item.getAttribute('data-option-value')) === normalizeOptionValue(optionValue);

            item.classList.toggle('is-selected', isSelected);
            item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });

          window.setTimeout(function () {
            updateDynamicText(modal);
            updateQuickviewLayoutMode(modal);
          }, 80);
          window.setTimeout(function () {
            updateDynamicText(modal);
            updateQuickviewLayoutMode(modal);
          }, 360);
        }

        return;
      }

      var infoOpen = event.target.closest('[data-ppb-info-open]');

      if (infoOpen) {
        var infoModal = modal.querySelector('[data-ppb-info-modal][data-qv-premium-modal]');

        if (infoModal) {
          event.preventDefault();
          infoModal.hidden = false;
          modal.classList.add('quickview-premium-info-open');
        }

        return;
      }

      var infoClose = event.target.closest('[data-ppb-info-close]');

      if (infoClose) {
        var closeModal = modal.querySelector('[data-ppb-info-modal][data-qv-premium-modal]');

        if (closeModal) {
          event.preventDefault();
          closeModal.hidden = true;
          modal.classList.remove('quickview-premium-info-open');
        }

        return;
      }

      var accordionToggle = event.target.closest('[data-ppb-accordion-toggle]');

      if (accordionToggle && modal.classList.contains('is-premium-synced')) {
        var accordion = accordionToggle.closest('.premium-product-builder__accordion');
        var accordionContent = accordion ? accordion.querySelector('[data-ppb-accordion-content]') : null;
        var isOpen = accordionToggle.getAttribute('aria-expanded') === 'true';

        event.preventDefault();
        accordionToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

        if (accordionContent) {
          accordionContent.classList.toggle('is-open', !isOpen);
        }
      }
    });

    document.addEventListener('keyup', function (event) {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('quick-add-modal.quickview-premium-info-open, .quick-add-modal.quickview-premium-info-open').forEach(function (modal) {
        var infoModal = modal.querySelector('[data-ppb-info-modal][data-qv-premium-modal]');

        if (infoModal) {
          infoModal.hidden = true;
          modal.classList.remove('quickview-premium-info-open');
        }
      });
    });

    var observer = new MutationObserver(function (mutations) {
      var shouldSync = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          var target = mutation.target;

          if (target && target.matches && target.matches('quick-add-modal, .quick-add-modal')) {
            shouldSync = true;
          }
        }

        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (!node || node.nodeType !== 1) return;

            if (
              (node.matches && node.matches('quick-add-modal, .quick-add-modal, .quick-add-modal__content-info, .product-info-container')) ||
              (node.querySelector && node.querySelector('quick-add-modal, .quick-add-modal, .quick-add-modal__content-info, .product-info-container'))
            ) {
              shouldSync = true;
            }
          });
        }
      });

      if (shouldSync) {
        scheduleOpenModals(140);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('quick-add-modal[open], quick-add-modal.is-open, quick-add-modal.active, .quick-add-modal[open], .quick-add-modal.is-open, .quick-add-modal.active').forEach(function (modal) {
        updateQuickviewLayoutMode(modal);
      });
    }, { passive: true });

    scheduleOpenModals(250);
  });
})();
/* HERBZ CART DRAWER CLEANUP - paste at the very bottom of assets/global.js */
(function () {
  if (window.HerbzCartDrawerCleanupLoaded) return;
  window.HerbzCartDrawerCleanupLoaded = true;

  var latestCart = null;
  var cleanupTimer = null;
  var fetchingCart = false;

  function getRootRoute() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getCartUrl(path) {
    return getRootRoute().replace(/\/$/, '') + '/' + path.replace(/^\//, '');
  }

  function formatMoney(cents) {
    cents = Number(cents || 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return (cents / 100).toLocaleString('da-DK', {
      style: 'currency',
      currency: 'DKK',
      minimumFractionDigits: 2
    }).replace('DKK', 'kr').trim();
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
  }

  function getSectionStoreCartRoot() {
    var sectionStoreCart = document.querySelector('section-store--cart-block');
    return sectionStoreCart && sectionStoreCart.shadowRoot ? sectionStoreCart.shadowRoot : null;
  }

  function styleSectionStoreCartImages(root) {
    if (!root) return;

    var styleId = 'herbz-section-store-cart-images';
    var style = root.getElementById ? root.getElementById(styleId) : root.querySelector('#' + styleId);

    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      style.textContent = [
        '/* Herbz cart media: remove the app\'s white image tiles. */',
        ':is([class*="cart-line"], [class*="upsell"], [class*="recommend"]) :is(picture, [class*="image"], [class*="media"], [class*="thumbnail"]):has(img) {',
        '  background: #18181A !important;',
        '  background-image: none !important;',
        '  box-shadow: none !important;',
        '}',
        ':is([class*="cart-line"], [class*="upsell"], [class*="recommend"]) img {',
        '  display: block !important;',
        '  max-width: 100% !important;',
        '  max-height: 100% !important;',
        '  object-fit: contain !important;',
        '  background: transparent !important;',
        '  box-shadow: none !important;',
        '}',
        '/* The parent becomes visually invisible against the cart when the source has alpha. */',
        ':is([class*="cart-line"], [class*="upsell"], [class*="recommend"]) .herbz-cart-media-shell {',
        '  background: #18181A !important;',
        '  background-image: none !important;',
        '  box-shadow: none !important;',
        '}',
        ':is([class*="upsell"], [class*="recommend"]) :is(.herbz-cart-media-shell, picture, [class*="image"], [class*="media"], [class*="thumbnail"]):has(img) {',
        '  background: #27272A !important;',
        '  background-image: none !important;',
        '}'
      ].join('\n');
      root.appendChild(style);
    }

    root.querySelectorAll([
      '[class*="cart-line"] img',
      '[class*="upsell"] img',
      '[class*="recommend"] img'
    ].join(',')).forEach(function (image) {
      var shell = image.parentElement && image.parentElement.closest(
        'picture, [class*="image"], [class*="media"], [class*="thumbnail"]'
      );
      if (!shell) shell = image.parentElement;
      if (shell) shell.classList.add('herbz-cart-media-shell');
    });
  }

  function getDisplayedCurrency() {
    var currencyFromBridge = document.documentElement.dataset.herbzCurrency;
    var vitalsDropdown = document.querySelector('.vitals-currency-converter-dropdown');
    var currencyFromVitals = vitalsDropdown && vitalsDropdown.dataset.selectedValue;

    if (currencyFromBridge) return String(currencyFromBridge).toUpperCase();
    if (currencyFromVitals) return String(currencyFromVitals).toUpperCase();

    var language = String(document.documentElement.lang || 'da').toLowerCase().split('-')[0];
    var currencyByLanguage = {
      da: 'DKK',
      en: 'EUR',
      sv: 'SEK',
      fr: 'EUR',
      de: 'EUR',
      es: 'EUR',
      it: 'EUR',
      cs: 'EUR'
    };

    return currencyByLanguage[language] || 'DKK';
  }

  function getCurrencyDisclaimerCopy() {
    var language = String(document.documentElement.lang || 'da').toLowerCase().split('-')[0];
    var copyByLanguage = {
      da: 'Priserne er i EUR, men betalingen trækkes i DKK. Din betalingsudbyder fastsætter valutakursen og kan opkræve et gebyr. Eksempel: 100 € ≈ 750 DKK.',
      en: 'Prices are in EUR, charged in DKK. Your provider sets the exchange rate and may charge a fee. Example: €100 ≈ 750 DKK.',
      sv: 'Priserna visas i SEK men debiteras i DKK. Din betalningsleverantör fastställer växelkursen och kan ta ut en avgift. Exempel: 100 SEK ≈ 67 DKK.',
      fr: 'Les prix sont en EUR, mais le paiement est débité en DKK. Votre prestataire fixe le taux de change et peut facturer des frais. Exemple : 100 € ≈ 750 DKK.',
      de: 'Die Preise sind in EUR angegeben, werden aber in DKK abgerechnet. Ihr Zahlungsanbieter legt den Wechselkurs fest und kann eine Gebühr berechnen. Beispiel: 100 € ≈ 750 DKK.',
      es: 'Los precios están en EUR, pero el cobro se realiza en DKK. Tu proveedor fija el tipo de cambio y puede cobrar una comisión. Ejemplo: 100 € ≈ 750 DKK.',
      it: 'I prezzi sono indicati in EUR, ma l’addebito viene effettuato in DKK. Il fornitore di pagamento stabilisce il tasso di cambio e può applicare una commissione. Esempio: 100 € ≈ 750 DKK.',
      cs: 'Ceny jsou uvedeny v EUR, ale účtovány v DKK. Váš poskytovatel plateb stanovuje směnný kurz a může účtovat poplatek. Příklad: 100 € ≈ 750 DKK.'
    };

    return copyByLanguage[language] || copyByLanguage.en;
  }

  function parseLocalizedCurrencyAmount(value) {
    var normalized = String(value || '')
      .replace(/[^0-9,.-]/g, '')
      .replace(/^-+/, '-');

    if (!normalized) return 0;

    var lastComma = normalized.lastIndexOf(',');
    var lastDot = normalized.lastIndexOf('.');
    var decimalSeparator = '';

    if (lastComma >= 0 && lastDot >= 0) {
      decimalSeparator = lastComma > lastDot ? ',' : '.';
    } else if (lastComma >= 0 && normalized.length - lastComma - 1 === 2) {
      decimalSeparator = ',';
    } else if (lastDot >= 0 && normalized.length - lastDot - 1 === 2) {
      decimalSeparator = '.';
    }

    if (decimalSeparator === ',') {
      normalized = normalized.replace(/\./g, '').replace(',', '.');
    } else if (decimalSeparator === '.') {
      normalized = normalized.replace(/,/g, '');
    } else {
      normalized = normalized.replace(/[,.]/g, '');
    }

    return Number(normalized) || 0;
  }

  function getVitalsExchangeRate(currency) {
    if (!currency || currency === 'DKK') return 1;

    var convertedAttribute = 'data-vitals-cc-' + currency.toLowerCase();
    var selector = '.money[data-vitals-cc-dkk][' + convertedAttribute + ']';
    var candidates = document.querySelectorAll(selector);

    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = candidates[index];
      var baseAmount = parseLocalizedCurrencyAmount(candidate.getAttribute('data-vitals-cc-dkk'));
      var convertedAmount = parseLocalizedCurrencyAmount(candidate.getAttribute(convertedAttribute));

      if (baseAmount > 0 && convertedAmount > 0) {
        window.__herbzVitalsExchangeRates = window.__herbzVitalsExchangeRates || {};
        window.__herbzVitalsExchangeRates[currency] = convertedAmount / baseAmount;
        return window.__herbzVitalsExchangeRates[currency];
      }
    }

    return window.__herbzVitalsExchangeRates && window.__herbzVitalsExchangeRates[currency]
      ? window.__herbzVitalsExchangeRates[currency]
      : 0;
  }

  function formatCurrencyAmount(amount, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(amount || 0));
    } catch (error) {
      return Number(amount || 0).toFixed(2) + ' ' + currency;
    }
  }

  function getChargedInDkkLabel() {
    var language = String(document.documentElement.lang || 'da').toLowerCase().split('-')[0];
    var labels = {
      da: 'Trækkes i DKK:',
      en: 'Charged in DKK:',
      sv: 'Debiteras i DKK:',
      fr: 'Débité en DKK :',
      de: 'Abbuchung in DKK:',
      es: 'Cobro en DKK:'
    };

    return labels[language] || labels.en;
  }

  function getElementBaseDkkCents(element) {
    if (!element) return 0;

    var storedCents = Number(element.dataset.herbzBaseDkkCents || 0);
    if (storedCents > 0) return storedCents;

    var parsedAmount = parseLocalizedCurrencyAmount(element.textContent.trim());
    var cents = Math.round(parsedAmount * 100);

    if (cents > 0) element.dataset.herbzBaseDkkCents = String(cents);
    return cents;
  }

  function setSectionStoreConvertedPrice(element, currency, rate) {
    var baseCents = getElementBaseDkkCents(element);
    if (!element || !baseCents || !rate) return;

    var convertedText = formatCurrencyAmount((baseCents / 100) * rate, currency);

    if (element.dataset.herbzCurrency === currency && element.textContent.trim() === convertedText) return;

    element.textContent = convertedText;
    element.dataset.herbzCurrency = currency;
    element.dataset.herbzRenderedText = convertedText;
  }

  function syncSectionStoreCartCurrency(root) {
    if (!root) return;

    var currency = getDisplayedCurrency();
    if (currency === 'DKK') return;

    var rate = getVitalsExchangeRate(currency);
    if (!rate) return;

    /* Always seed cart-line prices from Shopify's cart JSON. Never derive a
       DKK base price from text that Vitals or this script already converted. */
    if (latestCart && Array.isArray(latestCart.items)) {
      root.querySelectorAll('.cart-line-price').forEach(function (element, index) {
        var cartItem = latestCart.items[index];
        var baseCents = cartItem && Number(cartItem.final_line_price || cartItem.line_price || 0);
        if (baseCents > 0) element.dataset.herbzBaseDkkCents = String(baseCents);
      });
    }

    root.querySelectorAll([
      '.cart-line-price',
      '.cart-products-upsell-price',
      '.cart-products-upsell-compare-price',
      '.cart-order-upsell-price',
      '.cart-subtotal-compare'
    ].join(',')).forEach(function (element) {
      setSectionStoreConvertedPrice(element, currency, rate);
    });

    var subtotal = root.querySelector('.cart-subtotal-prices');

    if (subtotal) {
      var subtotalBaseCents = latestCart && Number(latestCart.total_price || 0);

      if (!subtotalBaseCents) subtotalBaseCents = getElementBaseDkkCents(subtotal);

      if (subtotalBaseCents > 0) {
        subtotal.dataset.herbzBaseDkkCents = String(subtotalBaseCents);
        var selectedTotalText = formatCurrencyAmount((subtotalBaseCents / 100) * rate, currency);
        var dkkTotalText = formatCurrencyAmount(subtotalBaseCents / 100, 'DKK');
        var currentSignature = currency + ':' + subtotalBaseCents + ':' + rate.toFixed(8);

        if (subtotal.dataset.herbzCurrencySignature !== currentSignature) {
          subtotal.replaceChildren();
          subtotal.style.cssText = 'display:flex;flex-direction:column;align-items:flex-end;gap:2px;text-align:right';

          var selectedTotal = document.createElement('span');
          selectedTotal.textContent = selectedTotalText;
          selectedTotal.style.cssText = 'display:block;color:#fafafa;font-size:16px;font-weight:850;line-height:1.15';

          var chargedTotal = document.createElement('span');
          chargedTotal.textContent = getChargedInDkkLabel() + ' ' + dkkTotalText;
          chargedTotal.style.cssText = 'display:block;color:#a1a1aa;font-size:11px;font-weight:650;line-height:1.25';

          subtotal.appendChild(selectedTotal);
          subtotal.appendChild(chargedTotal);
          subtotal.dataset.herbzCurrency = currency;
          subtotal.dataset.herbzCurrencySignature = currentSignature;
          subtotal.dataset.herbzRenderedText = subtotal.textContent.trim();
        }
      }
    }

    var checkoutText = root.querySelector('.cart-checkout-text');

    if (checkoutText) {
      var checkoutBaseCents = latestCart && Number(latestCart.total_price || 0);

      if (!checkoutBaseCents) checkoutBaseCents = getElementBaseDkkCents(checkoutText);

      if (checkoutBaseCents > 0) {
        checkoutText.dataset.herbzBaseDkkCents = String(checkoutBaseCents);
        var language = String(document.documentElement.lang || 'en').toLowerCase().split('-')[0];
        var checkoutLabels = {
          da: 'Gå til betaling',
          en: 'Checkout',
          sv: 'Till kassan',
          fr: 'Commander',
          de: 'Zur Kasse',
          es: 'Finalizar compra'
        };
        var checkoutLabel = checkoutLabels[language] || checkoutLabels.en;
        var checkoutPrice = formatCurrencyAmount((checkoutBaseCents / 100) * rate, currency);
        var checkoutDisplay = checkoutLabel + ' • ' + checkoutPrice;

        if (checkoutText.dataset.herbzCurrency !== currency || checkoutText.textContent.trim() !== checkoutDisplay) {
          checkoutText.textContent = checkoutDisplay;
          checkoutText.dataset.herbzCurrency = currency;
          checkoutText.dataset.herbzRenderedText = checkoutDisplay;
        }
      }
    }
  }

  function injectCurrencyDisclaimer(container) {
    if (!container) return;

    var currency = getDisplayedCurrency();
    var existing = container.querySelector('.herbz-currency-disclaimer');

    if (currency === 'DKK') {
      if (existing) existing.remove();
      return;
    }

    var footer = container.matches && container.matches('#main-cart-footer, .cart__footer, .cart-footer')
      ? container
      : container.querySelector('.cart-drawer__footer, .drawer__footer, #main-cart-footer, .cart__footer, .cart-footer');

    if (!footer) return;

    if (
      existing
      && existing.parentElement === footer
      && existing.dataset.currency === currency
    ) {
      return;
    }

    var copy = getCurrencyDisclaimerCopy();
    var disclaimer = existing || document.createElement('div');

    disclaimer.className = 'herbz-currency-disclaimer';
    disclaimer.setAttribute('role', 'note');
    disclaimer.dataset.currency = currency;
    disclaimer.replaceChildren();

    var icon = document.createElement('span');
    icon.className = 'herbz-currency-disclaimer__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = 'i';

    var text = document.createElement('p');
    text.textContent = copy;

    disclaimer.appendChild(icon);
    disclaimer.appendChild(text);

    if (typeof ShadowRoot !== 'undefined' && container instanceof ShadowRoot) {
      disclaimer.style.cssText = [
        'display:flex',
        'align-items:flex-start',
        'gap:10px',
        'width:100%',
        'margin:0 0 12px',
        'padding:11px 12px',
        'box-sizing:border-box',
        'color:rgba(250,250,250,.78)',
        'background:rgba(255,255,255,.055)',
        'border:1px solid rgba(255,255,255,.12)',
        'border-radius:8px',
        'font-size:12px',
        'font-weight:550',
        'line-height:1.4'
      ].join(';');
      icon.style.cssText = [
        'display:inline-grid',
        'place-items:center',
        'flex:0 0 19px',
        'width:19px',
        'height:19px',
        'margin-top:1px',
        'color:#18181b',
        'background:#e2e037',
        'border-radius:50%',
        'font-size:11px',
        'font-weight:900',
        'line-height:1'
      ].join(';');
      text.style.margin = '0';
    }

    if (!existing || existing.parentElement !== footer) {
      footer.prepend(disclaimer);
    }
  }

  function injectCurrencyDisclaimers() {
    injectCurrencyDisclaimer(getCartDrawer());
    var sectionStoreRoot = getSectionStoreCartRoot();
    styleSectionStoreCartImages(sectionStoreRoot);
    injectCurrencyDisclaimer(sectionStoreRoot);
    syncSectionStoreCartCurrency(sectionStoreRoot);

    document.querySelectorAll('#main-cart-footer, .cart__footer, .cart-footer').forEach(function (footer) {
      if (!footer.closest('cart-drawer, #CartDrawer, .cart-drawer')) {
        injectCurrencyDisclaimer(footer);
      }
    });
  }

  function fetchCart() {
    if (fetchingCart) return Promise.resolve(latestCart);
    fetchingCart = true;

    return fetch(getCartUrl('cart.js'), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      return response.json();
    }).then(function (cart) {
      latestCart = cart;
      return cart;
    }).catch(function () {
      return latestCart;
    }).finally(function () {
      fetchingCart = false;
    });
  }

  function hideElement(element) {
    if (!element) return;
    element.hidden = true;
    element.style.display = 'none';
  }

  function showElement(element) {
    if (!element) return;
    element.hidden = false;
    element.style.display = '';
  }

  function getLinePrice(cartItem, keys) {
    if (!cartItem) return 0;

    for (var index = 0; index < keys.length; index += 1) {
      var value = Number(cartItem[keys[index]]);
      if (Number.isFinite(value) && value > 0) return value;
    }

    return 0;
  }

  function getLineGrams(cartItem) {
    if (!cartItem) return '';

    var candidates = [];

    if (cartItem.variant_title) candidates.push(cartItem.variant_title);
    if (cartItem.title) candidates.push(cartItem.title);

    if (Array.isArray(cartItem.options_with_values)) {
      cartItem.options_with_values.forEach(function (option) {
        if (!option) return;
        if (option.name) candidates.push(option.name);
        if (option.value) candidates.push(option.value);
      });
    }

    if (cartItem.properties) {
      Object.keys(cartItem.properties).forEach(function (key) {
        var value = cartItem.properties[key];
        if (key) candidates.push(key);
        if (value) candidates.push(String(value));
      });
    }

    for (var index = 0; index < candidates.length; index += 1) {
      var match = String(candidates[index]).match(/([0-9]+)\s*g/i);
      if (match && match[1]) return match[1] + 'g';
    }

    return '';
  }

  function cleanProductTitle(item, cartItem) {
    if (!item || !cartItem || !cartItem.product_title) return;

    var name = item.querySelector('.cart-item__name, .cart-item__details a, a[href*="/products/"]');
    if (!name) return;

    name.textContent = cartItem.product_title;
  }

  function cleanProductOptions(item, cartItem) {
    if (!item) return;

    item.querySelectorAll('.product-option, dl, dt, dd').forEach(function (option) {
      hideElement(option);
    });

    var grams = getLineGrams(cartItem);
    var details = item.querySelector('.cart-item__details');
    if (!details || !grams) return;

    var existing = details.querySelector('.herbz-cart-clean-grams');
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'herbz-cart-clean-grams';
      details.appendChild(existing);
    }

    existing.textContent = 'Mængde: ' + grams;
  }

  function injectCleanPrice(item, cartItem) {
    if (!item || !cartItem) return;

    var totals = item.querySelector('.cart-item__totals');
    if (!totals) {
      totals = document.createElement('div');
      totals.className = 'cart-item__totals herbz-cart-clean-totals';
      item.appendChild(totals);
    }

    var quantity = Math.max(1, Number(cartItem.quantity || 1));
    var finalLinePrice = getLinePrice(cartItem, ['final_line_price', 'line_price']);
    var originalLinePrice = getLinePrice(cartItem, ['original_line_price']);

    if (!finalLinePrice && cartItem.final_price) {
      finalLinePrice = Number(cartItem.final_price || 0) * quantity;
    }

    if (!originalLinePrice && cartItem.original_price) {
      originalLinePrice = Number(cartItem.original_price || 0) * quantity;
    }

    if (!finalLinePrice) return;

    var compareLinePrice = originalLinePrice > finalLinePrice ? originalLinePrice : 0;
    var existing = totals.querySelector('.herbz-cart-clean-price');

    if (
      existing
      && existing.dataset.finalLinePrice === String(finalLinePrice)
      && existing.dataset.compareLinePrice === String(compareLinePrice)
    ) {
      return;
    }

    totals.querySelectorAll('.herbz-cart-clean-price').forEach(function (element) {
      element.remove();
    });

    var wrapper = document.createElement('div');
    var current = document.createElement('span');

    wrapper.className = 'herbz-cart-clean-price';
    wrapper.dataset.finalLinePrice = String(finalLinePrice);
    wrapper.dataset.compareLinePrice = String(compareLinePrice);
    current.className = 'herbz-cart-clean-current';
    current.textContent = formatMoney(finalLinePrice);
    wrapper.appendChild(current);

    if (compareLinePrice) {
      var compare = document.createElement('s');
      compare.className = 'herbz-cart-clean-compare';
      compare.textContent = formatMoney(compareLinePrice);
      wrapper.appendChild(compare);
    }

    totals.appendChild(wrapper);
  }

  function hideDuplicateLinePrices(item) {
    if (!item) return;

    item.querySelectorAll([
      '.cart-item__details .cart-item__price-wrapper',
      '.cart-item__details .cart-item__discounted-prices',
      '.cart-item__details .cart-item__final-price',
      '.cart-item__details .cart-item__old-price',
      '.cart-item__details .price',
      '.cart-item__details [class*="price"]',
      '.cart-item__details .money',
      '.cart-item__quantity .cart-item__price-wrapper',
      '.cart-item__quantity .cart-item__discounted-prices',
      '.cart-item__quantity .cart-item__final-price',
      '.cart-item__quantity .cart-item__old-price',
      '.cart-item__quantity .price',
      '.cart-item__quantity [class*="price"]',
      '.cart-item__quantity .money',
      '.cart-item__quantity s',
      '.cart-item__details s',
      '.cart-item__totals > *:not(.herbz-cart-clean-price)',
      '.cart-item__totals .cart-item__price-wrapper:not(.herbz-cart-clean-price)',
      '.cart-item__totals .cart-item__discounted-prices',
      '.cart-item__totals .cart-item__final-price',
      '.cart-item__totals .cart-item__old-price',
      '.cart-item__totals .price',
      '.cart-item__totals .money',
      '.cart-item__totals s:not(.herbz-cart-clean-compare)',
      '.discounts',
      '.discounts__discount',
      '.cart-item__discounts',
      '.cart-item__error',
      '.cart-item__error-text'
    ].join(',')).forEach(function (element) {
      if (!element.classList.contains('herbz-cart-clean-price')) hideElement(element);
    });
  }

  function normalizeEmptyState(drawer, cart) {
    if (!drawer) return;

    var itemCount = cart && typeof cart.item_count === 'number'
      ? cart.item_count
      : drawer.querySelectorAll('.cart-item').length;

    if (itemCount > 0) {
      drawer.classList.remove('is-empty');
      drawer.querySelectorAll([
        '.drawer__inner-empty',
        '.cart-drawer__empty-content',
        '.cart-drawer__empty',
        '.cart__empty-text',
        '.drawer__empty-text',
        '.cart__warnings',
        '.cart-drawer__warnings',
        '.empty-cart',
        '.cart-empty'
      ].join(',')).forEach(hideElement);
    } else {
      drawer.classList.add('is-empty');
    }
  }

  function cleanCartDrawer(cart) {
    var drawer = getCartDrawer();
    if (!drawer) {
      injectCurrencyDisclaimers();
      return;
    }

    normalizeEmptyState(drawer, cart);

    var cartItems = cart && Array.isArray(cart.items) ? cart.items : [];

    drawer.querySelectorAll('.cart-item').forEach(function (item, index) {
      var cartItem = cartItems[index];

      item.classList.add('herbz-cart-clean-line');
      cleanProductTitle(item, cartItem);
      cleanProductOptions(item, cartItem);
      injectCleanPrice(item, cartItem);
      hideDuplicateLinePrices(item);
    });

    injectCurrencyDisclaimers();
  }

  function scheduleCleanup(delay) {
    window.clearTimeout(cleanupTimer);

    cleanupTimer = window.setTimeout(function () {
      fetchCart().then(function (cart) {
        cleanCartDrawer(cart);
      });
    }, typeof delay === 'number' ? delay : 80);
  }

  function watchCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer || drawer.dataset.herbzCartCleanupObserver === 'true') return;

    drawer.dataset.herbzCartCleanupObserver = 'true';

    var observer = new MutationObserver(function () {
      scheduleCleanup(60);
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function watchSectionStoreCart() {
    var sectionStoreCart = document.querySelector('section-store--cart-block');
    var root = getSectionStoreCartRoot();

    if (!sectionStoreCart || !root || sectionStoreCart.dataset.herbzCurrencyObserver === 'true') return;

    sectionStoreCart.dataset.herbzCurrencyObserver = 'true';

    var observer = new MutationObserver(function () {
      scheduleCleanup(60);
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });

    styleSectionStoreCartImages(root);
    injectCurrencyDisclaimer(root);
  }

  function watchCartDrawerDuringStartup() {
    var attempts = 0;
    var maxAttempts = 8;

    function tryWatch() {
      watchCartDrawer();

      if (getCartDrawer() || attempts >= maxAttempts) return;

      attempts += 1;
      window.setTimeout(tryWatch, 500);
    }

    tryWatch();
  }

  function watchSectionStoreCartDuringStartup() {
    var attempts = 0;
    var maxAttempts = 20;

    function tryWatch() {
      watchSectionStoreCart();

      if (getSectionStoreCartRoot() || attempts >= maxAttempts) return;

      attempts += 1;
      window.setTimeout(tryWatch, 250);
    }

    tryWatch();
  }

  document.addEventListener('DOMContentLoaded', function () {
    watchCartDrawerDuringStartup();
    watchSectionStoreCartDuringStartup();
    scheduleCleanup(150);
  });

  document.addEventListener('shopify:section:load', function () {
    watchCartDrawer();
    watchSectionStoreCart();
    scheduleCleanup(150);
  });

  document.addEventListener('cart:updated', function () {
    scheduleCleanup(80);
  });

  document.addEventListener('cart-drawer:open', function () {
    scheduleCleanup(80);
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('cart-drawer')
      || event.target.closest('[href*="/cart"]')
      || event.target.closest('[aria-controls*="Cart"]')
      || event.target.closest('#cart-icon-bubble')
    ) {
      watchCartDrawer();
      watchSectionStoreCart();
      scheduleCleanup(120);
      window.setTimeout(function () {
        scheduleCleanup(300);
      }, 220);
    }
  }, true);
})();
